/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import axiosCancel from 'axios-cancel';
import axios from 'axios';
import moment from 'moment';
import { showSuccessToast, showErrorToast } from '../../../shared/utils/toastManager';

import {
  CLEAR_ORDER_OVERRIDES_START,
  CLEAR_ORDER_OVERRIDES_FULFILLED,
  CLEAR_ORDER_OVERRIDES_REJECTED,
  FETCH_CAL_WORKOUT_CALENDAR_FULFILLED,
  FETCH_CAL_WORKOUT_CALENDAR_START,
  FETCH_CAL_WORKOUT_CALENDAR_REJECTED,
  SET_SWAP_DROPDOWN_TOGGLE_ENABLED,
  SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN,
  SET_PRIMARY_SIDE_BAR_DATA_TAG,
  SET_SECONDARY_SIDE_BAR_DATA_TAG,
  SET_ACTIVE_MODAL,
  SET_ACTIVE_SECOND_LAYER_MODAL,
  SET_SELECTED_REDUX_CALENDAR,
  SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM,
  SET_IS_CLONE_DRAGGING,
  SET_COMBINE_WITH_ID,
  SET_CALENDAR_PANEL_CONTAINER_WIDTH,
  SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH,
  SET_HEADER_HEIGHT,
  SET_SIDE_BAR_EXERCISES_SEARCH_TERM,
  FETCH_ALL_EXERCISES_START,
  FETCH_ALL_EXERCISES_FULFILLED,
  FETCH_ALL_EXERCISES_REJECTED,
  SET_SELECTED_DATE,
  SET_SELECTED_MONTH,
  SET_FIRST_MONTH_IN_PICKER,
  SET_SELECTED_ITEMS,
  SET_SELECTED_ITEM,
  REMOVE_SELECTED_ITEM,
  SET_COPIED_SELECTED_ITEMS,
  SET_EXPANDED_ITEMS,
  SET_EXPANDED_ITEM,
  REMOVE_EXPANDED_ITEM,
  SET_WEEK_VIEW_EXPANDED_DAY,
  SET_ACTIVE_EXERCISE_ID,
  FOCUS_NEXT_PRESAVE_ITEM,
  FOCUS_NEXT_PRESAVE_PROGRAM_ITEM,
  SET_COMBINE_WITH_INFO,
  SET_SUPERSET_PICKER,
  FETCH_CALENDAR_ITEMS_START,
  FETCH_CALENDAR_ITEMS_FULFILLED,
  FETCH_CALENDAR_ITEMS_REJECTED,
  SAVE_CALENDAR_EXERCISE_START,
  SAVE_CALENDAR_EXERCISE_FULFILLED,
  SAVE_CALENDAR_EXERCISE_REJECTED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED,
  SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED,
  SET_CALENDAR_CONTAINER_SCROLL_POSITION,
  SET_ADD_INFO_CONTENT,
  SET_IFRAMELY_ERROR,
  UPLOAD_CALENDAR_MEDIA_START,
  UPLOAD_CALENDAR_MEDIA_FULFILLED,
  UPLOAD_CALENDAR_MEDIA_REJECTED,
  UPLOAD_MEDIA_BY_URL_START,
  UPLOAD_MEDIA_BY_URL_FULFILLED,
  UPLOAD_MEDIA_BY_URL_REJECTED,
  EDIT_THUMBNAIL_START,
  EDIT_THUMBNAIL_FULFUILLED,
  EDIT_THUMBNAIL_REJECTED,
  CREATE_EXERCISE_START,
  CREATE_EXERCISE_FULFILLED,
  CREATE_EXERCISE_REJECTED,
  FETCH_DOCUMENTS_START,
  FETCH_DOCUMENTS_FULFILLED,
  FETCH_DOCUMENTS_REJECTED,
  FETCH_DOCUMENT_START,
  FETCH_DOCUMENT_FULFILLED,
  FETCH_DOCUMENT_REJECTED,
  FETCH_FOLDER_START,
  FETCH_FOLDER_FULFILLED,
  FETCH_FOLDER_REJECTED,
  FETCH_PROGRAMMED_CALENDAR_ITEM_START,
  FETCH_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  FETCH_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  ADD_ASSET,
  FETCH_PARENT_CALENDARS_START,
  FETCH_PARENT_CALENDARS_FULFILLED,
  FETCH_PARENT_CALENDARS_REJECTED,
  FETCH_CALENDAR_SELECT_ATHLETES_START,
  FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED,
  FETCH_CALENDAR_SELECT_ATHLETES_REJECTED,
  SET_CLICKED_UPGRADE_NOW,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_START,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  UPDATE_SAVED_WORKOUT_ITEM_START,
  UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
  UPDATE_SAVED_WORKOUT_ITEM_REJECTED,
  UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_START,
  UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
  UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_REJECTED,
  FETCH_FUTURE_OCCURRENCES_COUNT_START,
  FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED,
  FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED,
  SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED,
  REVERT_SWAPPED_ITEM_START,
  REVERT_SWAPPED_ITEM_FULFILLED,
  REVERT_SWAPPED_ITEM_REJECTED,
  UPDATE_PRESAVED_CALENDAR_ITEM,
  UPDATE_PRESAVED_PROGRAM_ITEM,
  SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM,
  CREATE_TAG_FOR_ACCOUNT_START,
  CREATE_TAG_FOR_ACCOUNT_FULTILLED,
  CREATE_TAG_FOR_ACCOUNT_REJECTED,
  FETCH_ACCOUNT_TAGS_START,
  FETCH_ACCOUNT_TAGS_FULFILLED,
  FETCH_ACCOUNT_TAGS_REJECTED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY,
  ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY,
  SET_ON_BEFORE_CAPTURE,
  SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION,
  REMOVE_PRESAVE_ITEM_FROM_REDUX,
  REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX,
  LOG_REDUX_PRESAVE_ADD_INFO,
  LOG_REDUX_PRESAVE_DESCRIPTION,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED,
  FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED,
  CREATE_QUESTION_FOR_ACCOUNT_START,
  CREATE_QUESTION_FOR_ACCOUNT_FULTILLED,
  CREATE_QUESTION_FOR_ACCOUNT_REJECTED,
  CLEAR_NEWLY_CREATED_QUESTION,
  SET_QUESTION_COUNT,
  SET_DELETE_STACK,
  UPDATE_CALENDAR_ITEMS_ORDER_START,
  UPDATE_CALENDAR_ITEMS_ORDER_REJECTED,
  MULTI_MOVE_EXERCISE_BETWEEN_DATES_START,
  MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED,
  MULTI_MOVE_EXERCISE_BETWEEN_DATES_REJECTED,
  MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_START,
  MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED,
  MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_REJECTED,
  SET_SELECTED_REDUX_ATHLETE,
  SET_CALENDAR_ITEMS,
  SET_RECURRING_CALENDAR_ITEMS,
  CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS,
  CLEAR_AFTER_RECURRING_CALENDAR_ITEMS,
  CLEAR_CALENDAR_ITEMS,
  CLEAR_NON_DATE_BASED_PROGRAM_ITEMS,
  DELETE_SAVED_CALENDAR_ITEM_START,
  DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  DELETE_SAVED_CALENDAR_ITEM_REJECTED,
  DELETE_SAVED_WORKOUT_ITEM_START,
  DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  DELETE_SAVED_WORKOUT_ITEM_REJECTED,
  DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_START,
  DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_FULFILLED,
  DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_REJECTED,
  UNDO_DELETE_SAVED_WORKOUT_ITEM_START,
  UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_WORKOUT_ITEM_REJECTED,
  UNDO_DELETE_SAVED_CALENDAR_ITEM_START,
  UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
  UNDO_DELETE_SAVED_CALENDAR_ITEM_REJECTED,
  CONVERT_RECURRING_ITEM_START,
  CONVERT_RECURRING_ITEM_FULFILLED,
  CONVERT_RECURRING_ITEM_REJECTED,
  DELETE_RECURRING_ITEM_START,
  DELETE_RECURRING_ITEM_FULFILLED,
  DELETE_RECURRING_ITEM_REJECTED,
  FETCH_RECURRING_CALENDAR_ITEMS_START,
  FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED,
  FETCH_RECURRING_CALENDAR_ITEMS_REJECTED,
  UPDATE_RECURRING_ITEM_SCHEDULE_START,
  UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED,
  UPDATE_RECURRING_ITEM_SCHEDULE_REJECTED,
  SET_IS_DRAGGING,
  SET_DRAG_SOURCE,
  SET_DRAGGED_ITEM,
  SET_REDUX_CALENDAR_CONTAINERS,
  SET_PROGRAMMED_CALENDAR_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_ITEMS,
  SET_NON_DATE_BASED_PROGRAM_DAYS,
  FETCH_SAVED_WORKOUTS_START,
  FETCH_SAVED_WORKOUTS_FULFILLED,
  FETCH_SAVED_WORKOUTS_REJECTED,
  FETCH_SAVED_WORKOUT_DETAIL_START,
  FETCH_SAVED_WORKOUT_DETAIL_FULFILLED,
  FETCH_SAVED_WORKOUT_DETAIL_REJECTED,
  FETCH_SAVED_WORKOUT_START,
  FETCH_SAVED_WORKOUT_FULFILLED,
  FETCH_SAVED_WORKOUT_REJECTED,
  LOAD_SAVED_PROGRAM_START,
  LOAD_SAVED_PROGRAM_FULFILLED,
  LOAD_SAVED_PROGRAM_REJECTED,
  SET_LAST_UPDATE_TIME,
  UPDATE_WORKOUT_INFO_NAME_START,
  UPDATE_WORKOUT_INFO_NAME_FULFILLED,
  UPDATE_WORKOUT_INFO_NAME_REJECTED,
  UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_START,
  UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED,
  UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_REJECTED,
  TOGGLE_ANALYTICS_STRIKETHROUGH,
  UPDATE_WORKOUT_INFO_COLOR_START,
  UPDATE_WORKOUT_INFO_COLOR_FULFILLED,
  UPDATE_WORKOUT_INFO_COLOR_REJECTED,
  SAVE_WORKOUT_TEMPLATE,
  SAVE_WORKOUT_TEMPLATE_FULFILLED,
  SAVE_WORKOUT_TEMPLATE_REJECTED,
  SHARE_WORKOUT_INFO_START,
  SHARE_WORKOUT_INFO_FULFILLED,
  SHARE_WORKOUT_INFO_REJECTED,
  CLEAR_WORKOUT_ITEMS_START,
  CLEAR_WORKOUT_ITEMS_FULFILLED,
  CLEAR_WORKOUT_ITEMS_REJECTED,
  COPY_WORKOUT_ITEMS_START,
  COPY_WORKOUT_ITEMS_FULFILLED,
  COPY_WORKOUT_ITEMS_REJECTED,
  REVERT_LAST_KNOWN_CORRECT_ORDER,
  UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED,
  FETCH_CALENDAR_PICKER_ITEMS_START,
  FETCH_CALENDAR_PICKER_ITEMS_FULFILLED,
  FETCH_CALENDAR_PICKER_ITEMS_REJECTED,
  UPDATE_CALENDAR_SETTINGS_START,
  UPDATE_CALENDAR_SETTINGS_FULFILLED,
  UPDATE_CALENDAR_SETTINGS_REJECTED,
  SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN,
  SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN,
  SET_IS_SUPERSET_PICKER_OPEN,
  SET_SUPERSET_PICKER_OPEN_BY_ID,
  REMOVE_SUPERSET_PICKER_OPEN_BY_ID,
  FETCH_AND_SET_DEFAULT_CALENDAR_START,
  FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED,
  FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED,
  FETCH_AND_SET_URL_ATHLETE_START,
  FETCH_AND_SET_URL_ATHLETE_FULFILLED,
  FETCH_AND_SET_URL_ATHLETE_REJECTED,
  FETCH_AND_SET_URL_CALENDAR_START,
  FETCH_AND_SET_URL_CALENDAR_FULFILLED,
  FETCH_AND_SET_URL_CALENDAR_REJECTED,
  FETCH_AND_SET_URL_PROGRAM_START,
  FETCH_AND_SET_URL_PROGRAM_FULFILLED,
  FETCH_AND_SET_URL_PROGRAM_REJECTED,
  FETCH_EXERCISE_START,
  FETCH_EXERCISE_FULFILLED,
  FETCH_EXERCISE_REJECTED,
  SET_EXERCISE_PICKER_SEARCH_TERM,
  CREATE_PARENT_CALENDAR_START,
  CREATE_PARENT_CALENDAR_FULFILLED,
  CREATE_PARENT_CALENDAR_REJECTED,
  CREATE_A_SAVED_WORKOUT_START,
  CREATE_A_SAVED_WORKOUT_FULFILLED,
  CREATE_A_SAVED_WORKOUT_REJECTED,
  CREATE_PARENT_CHILD_CALENDAR_START,
  CREATE_PARENT_CHILD_CALENDAR_FULFILLED,
  CREATE_PARENT_CHILD_CALENDAR_REJECTED,
  FETCH_CURRENT_USER_START,
  FETCH_CURRENT_USER_FULFILLED,
  FETCH_CURRENT_USER_REJECTED,
  SET_SELECTED_SAVED_WORKOUT,
  CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER,
  SET_IS_BEFORE_RECURRING_SECTION_EXPANDED,
  SET_IS_AFTER_RECURRING_SECTION_EXPANDED,
  SET_PLACEHOLDER_INFO,
  SET_DRAG_IS_IN_PROGRESS,
  SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM,
  FETCH_WORKOUT_TEMPLATE_DATA_START,
  FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED,
  FETCH_WORKOUT_TEMPLATE_DATA_REJECTED,
  SET_VIEW_TYPE,
  SET_CALENDAR_ITEMS_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED,
  UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED,
  ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED,
  SET_COMBINE_WITH_INFO_NAMESPACED,
  SET_PROGRAM_TYPE,
  SET_CREATE_MODAL_PROGRAM_TYPE,
  SET_SELECTED_PROGRAM_DAY_NUMBER,
  SET_PRESAVE_TABLE_LOCAL_STATE,
  REMOVE_PRESAVE_TABLE_LOCAL_STATE,
  CLEAR_PRESAVE_TABLE_LOCAL_STATE,
  SET_SELECTED_START_DAY_OF_WEEK,
  SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK,
  SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK,
  SET_GROUP_BY_FILTER,
  SET_CURRENTLY_DISPLAYED_WEEKDAYS,
  SET_SELECTED_WEEK_VIEW_DAY_TOGGLE,
  UPDATE_WORKOUT_ITEMS_ORDER_START,
  UPDATE_WORKOUT_ITEMS_ORDER_FULFILLED,
  UPDATE_WORKOUT_ITEMS_ORDER_REJECTED,
  REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT,
  DUPLICATE_WEEK_START,
  DUPLICATE_WEEK_FULFILLED,
  DUPLICATE_WEEK_REJECTED,
  SET_ORDERING_INFO_MODAL_OPEN,
  SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED,
} from './actionTypes';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';

axiosCancel(axiosAuthed, {
  debug: true, // default
});

export const setLastUpdateTime = () => ({
  type: SET_LAST_UPDATE_TIME,
  payload: Date.now(),
});

export const clearMostRecentlyAddedCalendarItemTracker = () => ({
  type: CLEAR_MOST_RECENTLY_ADDED_CALENDAR_ITEM_TRACKER,
});

export const setPreSaveTableLocalState = (assignedId, stateObject) => ({
  type: SET_PRESAVE_TABLE_LOCAL_STATE,
  payload: { assignedId, stateObject },
});

export const removePreSaveTableLocalState = (assignedId) => ({
  type: REMOVE_PRESAVE_TABLE_LOCAL_STATE,
  payload: { assignedId },
});

export const clearPreSaveTableLocalState = () => ({
  type: CLEAR_PRESAVE_TABLE_LOCAL_STATE,
});

export const setOrderingInfoModalOpen = (isOpen) => ({
  type: SET_ORDERING_INFO_MODAL_OPEN,
  payload: isOpen,
});

export const fetchCurrentUser = () => (
  (dispatch) => {
    dispatch({ type: FETCH_CURRENT_USER_START });
    axios.get('/users/me', { crossDomain: true })
      .then((response) => {
        dispatch({ type: FETCH_CURRENT_USER_FULFILLED, payload: response.data });
      })
      .catch((err) => {
        dispatch({ type: FETCH_CURRENT_USER_REJECTED, payload: err });
      });
  }
);

export const getAssignedWorkoutItemsForAthleteByDate = (
  currentUser,
  firstDayMonth,
  lastDayMonth,
  userId,
) => (dispatch) => {
  dispatch({ type: FETCH_CALENDAR_ITEMS_START });
  axiosAuthed
    .get(`/accounts/${currentUser.accountCode}/calendars/programming?endDate=${lastDayMonth}&startDate=${firstDayMonth}&athleteId=${userId}`)
    .then((response) => {
      const object = {};
      // First, add all days returned from API
      for (let i = 0; i < response.data.assignments.length; i += 1) {
        object[response.data.assignments[i].date] = response.data.assignments[i];
      }

      // Fill in missing days between firstDayMonth and lastDayMonth with empty objects
      const startDate = moment(firstDayMonth);
      const endDate = moment(lastDayMonth);
      const currentDate = startDate.clone();

      while (currentDate.isSameOrBefore(endDate)) {
        const dateKey = currentDate.format('YYYY-MM-DD');
        if (!object[dateKey]) {
          object[dateKey] = {
            date: dateKey,
            exercises: [],
            repCount: 0,
            setCount: 0,
            totalVolumeLoad: 0,
          };
        }
        currentDate.add(1, 'day');
      }

      setTimeout(() => {
        dispatch({
          payload: {
            data: object,
            requestedRange: {
              start: firstDayMonth,
              end: lastDayMonth,
            },
          },
          type: FETCH_CALENDAR_ITEMS_FULFILLED,
        });
      }, 750);
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred getting calendar items');
      dispatch({
        payload:
            err?.response?.headers?.message
            || err?.response?.data?.message
            || 'An error has occurred getting calendar items',
        type: FETCH_CALENDAR_ITEMS_REJECTED,
      });
    });
};

export const getAssignedWorkoutItemsForCalendarByDate = (
  currentUser,
  firstDayMonth,
  lastDayMonth,
  calendarId,
) => (dispatch) => {
  dispatch({ type: FETCH_CALENDAR_ITEMS_START });
  axiosAuthed
    .get(`/accounts/${currentUser.accountCode}/calendars/programming?endDate=${lastDayMonth}&startDate=${firstDayMonth}&calendarId=${calendarId}`)
    .then((response) => {
      const object = {};
      // First, add all days returned from API
      for (let i = 0; i < response.data.assignments.length; i += 1) {
        object[response.data.assignments[i].date] = response.data.assignments[i];
      }

      // Fill in missing days between firstDayMonth and lastDayMonth with empty objects
      const startDate = moment(firstDayMonth);
      const endDate = moment(lastDayMonth);
      const currentDate = startDate.clone();

      while (currentDate.isSameOrBefore(endDate)) {
        const dateKey = currentDate.format('YYYY-MM-DD');
        if (!object[dateKey]) {
          object[dateKey] = {
            date: dateKey,
            exercises: [],
            repCount: 0,
            setCount: 0,
            totalVolumeLoad: 0,
          };
        }
        currentDate.add(1, 'day');
      }

      // Restore timeout for shimmer effect
      setTimeout(() => {
        dispatch({
          payload: {
            data: object,
            requestedRange: {
              start: firstDayMonth,
              end: lastDayMonth,
            },
          },
          type: FETCH_CALENDAR_ITEMS_FULFILLED,
        });
      }, 300);
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred getting calendar items');
      dispatch({
        payload:
            err?.response?.headers?.message
                || err?.response?.data?.message
                || 'An error has occurred getting calendar items',
        type: FETCH_CALENDAR_ITEMS_REJECTED,
      });
    });
};

export const clearOrderOverrides = (
  currentUser,
  endDate,
  startDate,
) => (dispatch, getState) => {
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  const submissionObject = {
    endDate,
    startDate,
  };

  if (Object.keys(selectedReduxCalendar).length) {
    submissionObject.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    submissionObject.userId = selectedReduxAthlete.id;
  }
  dispatch({ type: CLEAR_ORDER_OVERRIDES_START });
  axiosAuthed
    .patch(`/accounts/${currentUser.accountCode}/calendars/programming/clear-ord-overrides`, submissionObject)
    .then(() => {
      dispatch({
        payload: {},
        type: CLEAR_ORDER_OVERRIDES_FULFILLED,
      });
      /** hit get programming endpoint to refresh */
      if (Object.keys(selectedReduxCalendar).length) {
        dispatch(getAssignedWorkoutItemsForCalendarByDate(
          currentUser,
          startDate,
          endDate,
          selectedReduxCalendar.id,
        ));
      } else if (Object.keys(selectedReduxAthlete).length) {
        dispatch(getAssignedWorkoutItemsForAthleteByDate(
          currentUser,
          startDate,
          endDate,
          selectedReduxAthlete.id,
        ));
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred clearring order overrides!');
      dispatch({
        payload:
            err?.response?.headers?.message
                || err?.response?.data?.message
                || 'An error has occurred clearing order overrides',
        type: CLEAR_ORDER_OVERRIDES_REJECTED,
      });
    });
};

export const fetchNonDateBasedProgramItemsByDayRange = (accountCode, savedWorkoutId, startDay = null, endDay = null, refresh = false, weekNumber = null) => (dispatch) => {
  dispatch({ type: FETCH_SAVED_WORKOUT_START });
  const dayRangeParam = startDay !== undefined && startDay !== null
  && endDay !== undefined && endDay !== null
    ? `&startDay=${startDay}&endDay=${endDay}`
    : '';
  return axiosAuthed
    .get(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}?emptyDayFillStyle=0${dayRangeParam}`)
    .then((response) => {
      const object = {};
      for (let i = 0; i < response.data.programItems.length; i += 1) {
        object[response.data.programItems[i].dayNumber] = response.data.programItems[i];
      }
      setTimeout(() => {
        dispatch({
          type: FETCH_SAVED_WORKOUT_FULFILLED,
          payload: {
            data: object,
            savedWorkoutId,
            refresh,
            weekNumber,
          },
        });
      }, 350);
    })
    .catch((error) => {
      showErrorToast('Error loading saved workout details');
      dispatch({
        type: FETCH_SAVED_WORKOUT_REJECTED,
        payload: {
          error,
        },
      });
    });
};

export const getRecurringWorkoutsByDate = (
  currentUser,
  firstDayMonth,
  lastDayMonth,
  calendarId,
  forAthlete = false,
  { onSuccess, onError } = {},
) => (dispatch, getState) => {
  dispatch({ type: FETCH_RECURRING_CALENDAR_ITEMS_START });

  const idParam = forAthlete ? `athleteId=${calendarId}` : `calendarId=${calendarId}`;

  axiosAuthed
    .get(
      `/accounts/${currentUser.accountCode}/calendars/programming/recurring?endDate=${lastDayMonth}&startDate=${firstDayMonth}&${idParam}`,
    )
    .then((response) => {
      const getDatesInRange = (start, end) => {
        const dates = [];
        const current = moment(start);
        const last = moment(end || lastDayMonth);

        while (current.isSameOrBefore(last, 'day')) {
          dates.push(current.format('YYYY-MM-DD'));
          current.add(1, 'day');
        }

        return dates;
      };

      const beforeWorkoutsObject = {};
      const afterWorkoutsObject = {};

      // Add API assignments
      for (let i = 0; i < response.data.assignments.length; i += 1) {
        beforeWorkoutsObject[response.data.assignments[i].date] = response.data.assignments[i].beforeWorkoutExercises;
        afterWorkoutsObject[response.data.assignments[i].date] = response.data.assignments[i].afterWorkoutExercises;
      }

      // Add activeWithWorkoutAssignments with flag
      for (let i = 0; i < response.data.activeWithWorkoutAssignments.length; i += 1) {
        const state = getState();
        const { calendarItems } = state.calendar.data;
        const assignment = response.data.activeWithWorkoutAssignments[i];
        const { startDate, endDate, position } = assignment.schedule;

        const targetDates = getDatesInRange(startDate, endDate);

        for (let d = 0; d < targetDates.length; d += 1) {
          const date = targetDates[d];
          const calendarDay = calendarItems[date];

          if (calendarDay && Array.isArray(calendarDay.exercises)) {
            const hasAssignedExercise = calendarDay.exercises.some(
              (ex) => typeof ex.assignedId === 'number',
            );

            if (hasAssignedExercise) {
              const assignmentWithFlag = { ...assignment, isActiveWithWorkoutAssignment: true };

              if (position === 0) {
                if (!beforeWorkoutsObject[date]) beforeWorkoutsObject[date] = [];
                beforeWorkoutsObject[date].push(assignmentWithFlag);
              } else {
                if (!afterWorkoutsObject[date]) afterWorkoutsObject[date] = [];
                afterWorkoutsObject[date].push(assignmentWithFlag);
              }
            }
          }
        }
      }

      // Fill missing dates with empty arrays
      const startDate = moment(firstDayMonth);
      const endDate = moment(lastDayMonth);
      const currentDate = startDate.clone();

      while (currentDate.isSameOrBefore(endDate)) {
        const dateKey = currentDate.format('YYYY-MM-DD');
        if (!beforeWorkoutsObject[dateKey]) beforeWorkoutsObject[dateKey] = [];
        if (!afterWorkoutsObject[dateKey]) afterWorkoutsObject[dateKey] = [];
        currentDate.add(1, 'day');
      }

      // Deduplicate by assignedId, preferring items with the activeWithWorkout flag
      const removeDuplicates = (workoutsObject) => {
        const keys = Object.keys(workoutsObject);
        for (let i = 0; i < keys.length; i += 1) {
          const date = keys[i];
          const map = new Map();
          workoutsObject[date].forEach((ex) => {
            if (!ex.assignedId) return;
            const existing = map.get(ex.assignedId);
            // Prefer the one with the flag
            if (!existing || ex.isActiveWithWorkoutAssignment) {
              map.set(ex.assignedId, ex);
            }
          });
          // eslint-disable-next-line no-param-reassign
          workoutsObject[date] = Array.from(map.values());
        }
      };

      removeDuplicates(beforeWorkoutsObject);
      removeDuplicates(afterWorkoutsObject);

      dispatch({
        payload: {
          data: {
            beforeWorkoutsObject,
            afterWorkoutsObject,
          },
          requestedRange: {
            start: firstDayMonth,
            end: lastDayMonth,
          },
        },
        type: FETCH_RECURRING_CALENDAR_ITEMS_FULFILLED,
      });

      if (onSuccess) onSuccess(response.data);
    })
    .catch((err) => {
      showErrorToast(
        err?.response?.headers?.message
          || 'An error has occurred getting recurring calendar items',
      );
      dispatch({
        payload:
          err?.response?.headers?.message
          || err?.response?.data?.message
          || 'An error has occurred getting recurring calendar items',
        type: FETCH_RECURRING_CALENDAR_ITEMS_REJECTED,
      });
      if (onError) onError(err.message);
    });
};

export const fetchParentCalendars = (
  accountCode,
) => (dispatch) => {
  dispatch({ type: FETCH_PARENT_CALENDARS_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/calendars?archived=0`)
    .then((response) => {
      setTimeout(() => {
        dispatch({
          payload: {
            data: response.data,
          },
          type: FETCH_PARENT_CALENDARS_FULFILLED,
        });
      }, 300);
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred fetching calendars');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error fetching workouts',
        type: FETCH_PARENT_CALENDARS_REJECTED,
      });
    });
};

export const fetchSavedWorkouts = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_SAVED_WORKOUTS_START });
  return axiosAuthed
    .get(`/accounts/${accountCode}/workouts/saved-workouts`)
    .then((response) => {
      dispatch({
        type: FETCH_SAVED_WORKOUTS_FULFILLED,
        payload: {
          data: response.data,
        },
      });
    })
    .catch((error) => {
      showErrorToast('Error loading saved workouts');
      dispatch({
        type: FETCH_SAVED_WORKOUTS_REJECTED,
        payload: {
          error,
        },
      });
    });
};

export const fetchSavedWorkoutDetail = (accountCode, savedWorkoutId) => (dispatch) => {
  dispatch({ type: FETCH_SAVED_WORKOUT_DETAIL_START });
  return axiosAuthed
    .get(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}?emptyDayFillStyle=1`)
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: FETCH_SAVED_WORKOUT_DETAIL_FULFILLED,
          payload: {
            data: response.data,
          },
        });
      }, 350);
    })
    .catch((error) => {
      showErrorToast('Error loading saved workout details');
      dispatch({
        type: FETCH_SAVED_WORKOUT_DETAIL_REJECTED,
        payload: {
          error,
        },
      });
    });
};

// export const fetchNonDateBasedProgramItemsByDayRange = (accountCode, savedWorkoutId, startDay = null, endDay = null) => (dispatch) => {
//   dispatch({ type: FETCH_SAVED_WORKOUT_START });
//   const dayRangeParam = startDay !== undefined && startDay !== null
//   && endDay !== undefined && endDay !== null
//     ? `&startDay=${startDay}&endDay=${endDay}`
//     : '';
//   return axiosAuthed
//     .get(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}?emptyDayFillStyle=0${dayRangeParam}`)
//     .then((response) => {
//       setTimeout(() => {
//         dispatch({
//           type: FETCH_SAVED_WORKOUT_FULFILLED,
//           payload: {
//             data: response.data.programItems,
//             savedWorkoutId,
//           },
//         });
//       }, 350);
//     })
//     .catch((error) => {
//       toast.error('Error loading saved workout details');
//       dispatch({
//         type: FETCH_SAVED_WORKOUT_REJECTED,
//         payload: {
//           error,
//         },
//       });
//     });
// };

export const setSelectedReduxNonDateBasedProgram = (program) => (
  {
    type: SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM,
    payload: program,
  }
);
export const setSelectedProgramDayNumber = (dayNumber) => (
  {
    type: SET_SELECTED_PROGRAM_DAY_NUMBER,
    payload: dayNumber,
  }
);

export const undoDeleteSavedWorkoutItem = (
  accountCode,
  assignedIds,
  savedWorkoutId,
) => (dispatch) => {
  dispatch({ type: UNDO_DELETE_SAVED_WORKOUT_ITEM_START });

  axiosAuthed
    .post(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming/undo-delete`, {
      assignedIds,
    })
    .then((response) => {
      showSuccessToast('Delete undone');
      dispatch({
        payload: {
          data: response.data,
          assignedIds,
        },
        type: UNDO_DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred undoing delete');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error undoing delete',
        type: UNDO_DELETE_SAVED_WORKOUT_ITEM_REJECTED,
      });
    });
};

export const deleteSavedWorkoutItem = (
  accountCode,
  assignedIds,
  index,
  dayNumber,
  exerciseNames = [],
) => (dispatch, getState) => {
  dispatch({ type: DELETE_SAVED_WORKOUT_ITEM_START });
  const { selectedReduxNonDateBasedProgram } = getState().calendar.data;

  let savedWorkoutId = null;

  if (Object.keys(selectedReduxNonDateBasedProgram).length) {
    savedWorkoutId = selectedReduxNonDateBasedProgram.id;
  }

  axiosAuthed
    .delete(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming`, { data: { assignedIds } })
    .then(() => {
      let message = 'Exercise deleted';
      if (exerciseNames.length === 1) {
        message = `${exerciseNames[0]} deleted`;
      } else if (exerciseNames.length > 1) {
        const remainingCount = exerciseNames.length - 1;
        message = `${exerciseNames[0]} and ${remainingCount} ${remainingCount === 1 ? 'other' : 'others'} deleted`;
      }

      const onUndo = () => {
        dispatch(undoDeleteSavedWorkoutItem(accountCode, assignedIds, savedWorkoutId));
      };

      showSuccessToast(message, onUndo);
      dispatch({
        payload: {
          data: {
            index, dayNumber, assignedIds,
          },
        },
        type: DELETE_SAVED_WORKOUT_ITEM_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred deleting item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error deleting item',
        type: DELETE_SAVED_WORKOUT_ITEM_REJECTED,
      });
    });
};

export const deleteSavedWorkoutItemsForWeek = (
  accountCode,
  assignedIds,
  weekNumber,
) => (dispatch, getState) => {
  dispatch({ type: DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_START });
  const { selectedReduxNonDateBasedProgram } = getState().calendar.data;

  let savedWorkoutId = null;

  if (Object.keys(selectedReduxNonDateBasedProgram).length) {
    savedWorkoutId = selectedReduxNonDateBasedProgram.id;
  }

  axiosAuthed
    .delete(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming`, { data: { assignedIds } })
    .then(() => {
      dispatch({ type: DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_FULFILLED });
      const refresh = true;
      dispatch(fetchNonDateBasedProgramItemsByDayRange(accountCode, savedWorkoutId, null, null, refresh, weekNumber));
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred deleting item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error deleting week items',
        type: DELETE_SAVED_WORKOUT_ITEMS_FOR_WEEK_REJECTED,
      });
    });
};

export const convertRecurringItem = (
  accountCode,
  submissionObject,
  assignedId,
  index,
  date,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: CONVERT_RECURRING_ITEM_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/calendars/programming/${assignedId}/recurring`, submissionObject)
    .then((response) => {
      dispatch({
        payload: {
          data: response.data, index, date, position: submissionObject.position === 1 ? 'afterRecurringWorkouts' : 'beforeRecurringWorkouts',
        },
        type: CONVERT_RECURRING_ITEM_FULFILLED,
      });
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred creating recurring item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error setting recurring item',
        type: CONVERT_RECURRING_ITEM_REJECTED,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

export const deleteRecurringItem = (
  accountCode,
  assignedId,
  date,
  isRecurring,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: DELETE_RECURRING_ITEM_START });
  axiosAuthed
    .delete(`/accounts/${accountCode}/calendars/programming/${assignedId}/recurring`)
    .then(() => {
      dispatch({
        payload: {
          data: {
            date, isRecurring, assignedId,
          },
        },
        type: DELETE_RECURRING_ITEM_FULFILLED,
      });
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred trying to delete recurring item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error deleting recurring item',
        type: DELETE_RECURRING_ITEM_REJECTED,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

export const updateRecurringItemSchedule = (
  accountCode,
  submissionObject,
  assignedId,
  index,
  date,
  prevPosition,
  { onSuccess, onError } = {},
) => (dispatch) => {
  dispatch({ type: UPDATE_RECURRING_ITEM_SCHEDULE_START });
  axiosAuthed
    .put(`/accounts/${accountCode}/calendars/programming/${assignedId}/recurring`, submissionObject)
    .then((response) => {
      showSuccessToast('Recurring schedule updated!');
      dispatch({
        payload: {
          data: response.data,
          index,
          date,
          position: response.data.schedule.position === 1 ? 'afterRecurringWorkouts' : 'beforeRecurringWorkouts',
          shouldSwitch: (prevPosition === 'before' && response.data.schedule.position === 1) || (prevPosition === 'after' && response.data.schedule.position === 0),
          prevPosition: prevPosition === 'before' ? 'beforeRecurringWorkouts' : 'afterRecurringWorkouts',
        },
        type: UPDATE_RECURRING_ITEM_SCHEDULE_FULFILLED,
      });
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred updating recurring item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error updating recurring item',
        type: UPDATE_RECURRING_ITEM_SCHEDULE_REJECTED,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

export const updateRecurringItem = (
  accountCode,
  submissionObject,
  assignedId,
  index,
  date,
) => (dispatch) => {
  dispatch({ type: CONVERT_RECURRING_ITEM_START });
  axiosAuthed
    .put(`/accounts/${accountCode}/calendars/programming/${assignedId}/recurring`, submissionObject)
    .then((response) => {
      showSuccessToast('Recurring schedule updated!');
      dispatch({
        payload: {
          data: response.data, index, date,
        },
        type: CONVERT_RECURRING_ITEM_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred creating recurring item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error setting recurring item',
        type: CONVERT_RECURRING_ITEM_REJECTED,
      });
    });
};

export const revertLastKnownCorrectOrder = (date, originalItems) => ({
  type: REVERT_LAST_KNOWN_CORRECT_ORDER,
  payload: { date, originalItems },
});

export const revertLastKnownCorrectOrderForSavedWorkout = (dayNumber, originalItems) => ({
  type: REVERT_LAST_KNOWN_CORRECT_ORDER_FOR_SAVED_WORKOUT,
  payload: { dayNumber, originalItems },
});

export const updateCalendarItemsOrder = (
  accountCode,
  newlyOrderedItems,
  originalItems = null,
) => (dispatch, getState) => {
  const newValues = { ...newlyOrderedItems };
  /** Filter out string IDs - string ids are pre save items */
  if (Array.isArray(newValues.assignedIdsBeingMoved)) {
    newValues.assignedIdsBeingMoved = newValues.assignedIdsBeingMoved.filter((id) => typeof id !== 'string');
  }
  /** If nothing left after filtering or moveToIndex does not not exist (-1), do NOT hit the endpoint */
  if (!newValues.assignedIdsBeingMoved?.length || newValues?.movedToIndex === -1) {
    return Promise.resolve();
  }
  dispatch({ type: UPDATE_CALENDAR_ITEMS_ORDER_START });
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  /** Only strip the opposite key when we're about to set ours - so we never end up with neither */
  if (Object.keys(selectedReduxCalendar).length) {
    delete newValues.userCalendarId;
    newValues.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    delete newValues.calendarId;
    newValues.userCalendarId = selectedReduxAthlete.id;
  }

  return axiosAuthed
    .put(`/accounts/${accountCode}/calendars/programming/reorder`, newValues)
    .then(() => {
      dispatch({
        type: UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'Could not complete reordering, reverting to original order');
      // If we have original items and the request failed, revert to the original order
      if (originalItems) {
        dispatch(revertLastKnownCorrectOrder(newlyOrderedItems.date, originalItems));
      }
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error',
        type: UPDATE_CALENDAR_ITEMS_ORDER_REJECTED,
      });
      throw err;
    });
};

export const updateCalendarItemsOrderAfterDelete = (
  accountCode,
  newlyOrderedItems,
) => (dispatch, getState) => {
  const newValues = { ...newlyOrderedItems };
  /** Filter out string IDs - string ids are pre save items */
  if (Array.isArray(newValues.order)) {
    newValues.order = newValues.order.filter((id) => typeof id !== 'string');
  }

  dispatch({ type: UPDATE_CALENDAR_ITEMS_ORDER_START });
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  /** Only strip the opposite key when we're about to set ours - so we never end up with neither */
  if (Object.keys(selectedReduxCalendar).length) {
    delete newValues.userCalendarId;
    newValues.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    delete newValues.calendarId;
    newValues.userCalendarId = selectedReduxAthlete.id;
  }

  return axiosAuthed
    .put(`/accounts/${accountCode}/calendars/programming/reorder`, newValues)
    .then(() => {
      dispatch({
        type: UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'Could not complete reordering');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error',
        type: UPDATE_CALENDAR_ITEMS_ORDER_REJECTED,
      });
      throw err;
    });
};

export const undoDeleteSavedCalendarItem = (
  accountCode,
  assignedIds,
  calendarId,
  userId,
) => (dispatch, getState) => {
  dispatch({ type: UNDO_DELETE_SAVED_CALENDAR_ITEM_START });

  const submissionObject = { assignedIds };
  if (calendarId) {
    submissionObject.calendarId = calendarId;
  } else if (userId) {
    submissionObject.userId = userId;
  }

  axiosAuthed
    .post(
      `/accounts/${accountCode}/calendars/programming/undo-delete`,
      submissionObject,
    )
    .then((response) => {
      showSuccessToast('Delete undone');

      /** Read metadata and current exercises before FULFILLED clears it */
      const { undoDeleteMetadata, calendarItems } = getState().calendar.data;
      const metadataKey = [...assignedIds].sort().join(',');
      const metadata = undoDeleteMetadata[metadataKey];

      dispatch({
        payload: { data: response.data, assignedIds },
        type: UNDO_DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
      });

      /** Reconstruct the restored order and call the reorder endpoint */
      if (metadata && metadata.kind === 'calendar' && response.data?.length) {
        const { date, deletedItemsWithIndices } = metadata;
        const exercises = [...(calendarItems[date]?.exercises || [])];

        let skipped = 0;
        deletedItemsWithIndices.forEach(({ item, index }) => {
          const restoredItem = response.data.find(
            (r) => r.assignedId === item.assignedId,
          );
          if (restoredItem) {
            const insertAt = Math.min(index - skipped, exercises.length);
            exercises.splice(insertAt, 0, restoredItem);
          } else {
            skipped += 1;
          }
        });

        const orderSubmissionObject = {
          date,
          order: exercises
            .map((ex) => ex.assignedId)
            .filter((id) => typeof id !== 'string'),
          assignedIdsBeingMoved: [],
          movedToIndex: -1,
        };

        dispatch(updateCalendarItemsOrderAfterDelete(accountCode, orderSubmissionObject));
      }
    })
    .catch((err) => {
      showErrorToast(
        err?.response?.headers?.message
        || 'An error has occurred undoing delete',
      );
      dispatch({
        payload:
          err?.response?.headers?.message
          || 'Unexpected error undoing delete',
        type: UNDO_DELETE_SAVED_CALENDAR_ITEM_REJECTED,
      });
    });
};

export const deleteSavedCalendarItem = (
  accountCode,
  assignedIds,
  index,
  date,
  isRecurring,
  calendarItemsBeforeDelete,
  exerciseNames = [],
) => (dispatch, getState) => {
  dispatch({ type: DELETE_SAVED_CALENDAR_ITEM_START });
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;

  const filteredOrderedAssignmentIds = calendarItemsBeforeDelete
    .filter((item) => !assignedIds.includes(item.assignedId))
    .map((item) => item.assignedId);

  const submissionObject = { };
  let calendarId = null;
  let userId = null;

  if (Object.keys(selectedReduxCalendar).length) {
    submissionObject.calendarId = selectedReduxCalendar.id;
    calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    submissionObject.userCalendarId = selectedReduxAthlete.id;
    userId = selectedReduxAthlete.id;
  }

  axiosAuthed
    .delete(`/accounts/${accountCode}/calendars/programming/assignments`, { data: { ...submissionObject, assignedIds } })
    .then(() => {
      let message = 'Exercise deleted';
      if (exerciseNames.length === 1) {
        message = `${exerciseNames[0]} deleted`;
      } else if (exerciseNames.length > 1) {
        const remainingCount = exerciseNames.length - 1;
        message = `${exerciseNames[0]} and ${remainingCount} ${remainingCount === 1 ? 'other' : 'others'} deleted`;
      }

      const onUndo = () => {
        dispatch(undoDeleteSavedCalendarItem(
          accountCode,
          assignedIds,
          calendarId,
          userId,
        ));
      };

      showSuccessToast(message, onUndo);
      dispatch({
        payload: {
          data: {
            index, date, isRecurring, assignedIds,
          },
        },
        type: DELETE_SAVED_CALENDAR_ITEM_FULFILLED,
      });
      const orderSubmissionObject = {
        date,
        order: filteredOrderedAssignmentIds,
        assignedIdsBeingMoved: [],
        movedToIndex: -1,
      };

      /** only hit reorder if there are items left after delete to be reordered */
      if (filteredOrderedAssignmentIds?.length > 0) {
        dispatch(updateCalendarItemsOrderAfterDelete(accountCode, orderSubmissionObject));
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred deleting item');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error deleting item',
        type: DELETE_SAVED_CALENDAR_ITEM_REJECTED,
      });
    });
};

export const updateWorkoutItemsOrder = (
  accountCode,
  newlyOrderedItems,
  originalItems = null,
) => (dispatch, getState) => {
  dispatch({ type: UPDATE_WORKOUT_ITEMS_ORDER_START });
  const { selectedReduxNonDateBasedProgram } = getState().calendar.data;

  /** we need to make sure we are filtering out preSave items here->
   * pre save items have string ids that will cause errors and should not be sent
   * to the endpoint
   */
  const filteredOrder = newlyOrderedItems?.order.filter((id) => typeof id !== 'string');
  const newValues = {
    ...newlyOrderedItems,
    dayNumber: Number(newlyOrderedItems.dayNumber),
  };
  newValues.order = filteredOrder;

  let savedWorkoutId;

  if (Object.keys(selectedReduxNonDateBasedProgram).length) {
    savedWorkoutId = selectedReduxNonDateBasedProgram.id;
  }
  return axiosAuthed
    .put(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming/reorder`, newValues)
    .then(() => {
      dispatch({
        type: UPDATE_WORKOUT_ITEMS_ORDER_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'Could not complete reordering, reverting to original order');
      // If we have original items and the request failed, revert to the original order
      if (originalItems) {
        dispatch(revertLastKnownCorrectOrderForSavedWorkout(newlyOrderedItems.dayNumber, originalItems));
      }
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error',
        type: UPDATE_WORKOUT_ITEMS_ORDER_REJECTED,
      });
      throw err;
    });
};

export const moveExerciseBetweenDatesMultiEnabled = (
  accountCode,
  assignedIds,
  targetDate,
  sourceDate,
  destinationDate,
  newEndItems,
  { onSuccess, onError } = {},
) => async (dispatch, getState) => {
  dispatch({ type: MULTI_MOVE_EXERCISE_BETWEEN_DATES_START });

  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  const submissionObject = {
    assignedIds,
    date: targetDate,
  };

  if (Object.keys(selectedReduxCalendar).length) {
    submissionObject.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    submissionObject.userId = selectedReduxAthlete.id;
  }

  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/calendars/programming/change-date`,
      submissionObject,
    );

    dispatch({
      type: MULTI_MOVE_EXERCISE_BETWEEN_DATES_FULFILLED,
      payload: {
        data: response.data,
        assignedIds,
        sourceDate,
        destinationDate,
        targetDate,
      },
    });
    if (onSuccess) {
      onSuccess(response.data);
    }

    /** After successful move, update the calendar items order for the target date */
    const destinationDateFormatted = moment(targetDate).format('YYYY-MM-DD');
    /** filter out pre saved items - pre save items have string ids */
    const currentIdsOnTargetDate = new Set(
      (getState().calendar.data.calendarItems[destinationDateFormatted]?.exercises || [])
        .map((e) => e.assignedId),
    );
    /** adding another filter for currentIdsOnTargetDay to make sure
     * if we have subsequent move between day calls we won't run into
     * the error that says the reorder endpoint is trying to move items
     * that are not on the correct date.
     * if we run into any issue with this update we can go back to the original code
     * by removing '&& currentIdsOnTargetDate.has(id)'
     */
    const filteredOrder = newEndItems
      .map((item) => item.assignedId)
      .filter((id) => typeof id !== 'string' && currentIdsOnTargetDate.has(id));

    try {
      /** Call updateCalendarItemsOrder with the target date and new order */
      await dispatch(updateCalendarItemsOrder(accountCode, {
        date: destinationDateFormatted,
        order: filteredOrder,
        assignedIdsBeingMoved: assignedIds,
        /** this index could be -1 if the item being moved is a pre save
       * item. It wouln't exist in the filteredOrder because we filtered them out
       * that is ok because we are handling this scenario in the
       * order action where we just return and don't hit the endpoint
       * if assignedIdsBeingMoved is empty because we filter assignedIdsBeingMoved in the action
       */
        movedToIndex: filteredOrder.indexOf(assignedIds[0]),
      }));
    } catch (e) {
      showErrorToast('Failed to reorder calendar items');
    }

    return response.data;
  } catch (error) {
    showErrorToast(error?.response?.headers?.message || 'Failed to move exercise between dates');
    dispatch({
      type: MULTI_MOVE_EXERCISE_BETWEEN_DATES_REJECTED,
      payload: {
        error: error?.response?.headers?.message || error.message,
        assignedIds,
        sourceDate,
        destinationDate,
      },
    });
    if (onError) {
      onError(error.message);
    }
    throw error;
  }
};

export const moveNonDateBasedExerciseBetweenDays = (
  accountCode,
  assignedIds,
  targetDayNumber,
  sourceDayNumber,
  destinationDayNumber,
  newEndItems,
  { onSuccess, onError } = {},
) => async (dispatch, getState) => {
  const { selectedReduxNonDateBasedProgram } = getState().calendar.data;
  const dayNumberForEndpoint = Number(targetDayNumber);

  dispatch({ type: MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_START });

  const submissionObject = {
    assignedIds,
    dayNumber: dayNumberForEndpoint,
  };

  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/workouts/saved-workouts/${selectedReduxNonDateBasedProgram.id}/programming/change-day`,
      submissionObject,
    );
    dispatch({
      type: MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_FULFILLED,
      payload: {
        data: response.data,
        assignedIds,
        sourceDayNumber: Number(sourceDayNumber),
        destinationDayNumber: Number(destinationDayNumber),
        targetDayNumber: Number(targetDayNumber),
      },
    });
    if (onSuccess) {
      onSuccess(response.data);
    }
    /** After successful move, update the calendar items order for the target date */
    const currentIdsOnTargetDay = new Set(
      (getState().calendar.data.nonDateBasedProgramItems[dayNumberForEndpoint]?.exercises || [])
        .map((e) => e.assignedId),
    );

    /** adding another filter for currentIdsOnTargetDay to make sure
     * if we have subsequent move between day calls we won't run into
     * the error that says the reorder endpoint is trying to move items
     * that are not on the correct day number.
     * if we run into any issue with this update we can go back to the original code
     * const order = newEndItems.map((endItem) => endItem.assignedId);
     */
    const order = newEndItems
      .map((endItem) => endItem.assignedId)
      .filter((id) => currentIdsOnTargetDay.has(id));

    /** Call updateCalendarItemsOrder with the target date and new order */
    try {
      await dispatch(
        updateWorkoutItemsOrder(accountCode, {
          dayNumber: Number(targetDayNumber),
          order,
        }),
      );
    } catch (error) {
      showErrorToast('Failed to reorder items');
    }

    return response.data;
  } catch (error) {
    showErrorToast(error?.response?.headers?.message || 'Failed to move exercise between dates');
    dispatch({
      type: MOVE_NON_DATE_BASED_EXERCISE_BETWEEN_DAYS_REJECTED,
      payload: {
        error: error?.response?.headers?.message || error.message,
        assignedIds,
        sourceDayNumber: Number(sourceDayNumber),
        destinationDayNumber: Number(destinationDayNumber),
      },
    });
    if (onError) {
      onError(error.message);
    }
    throw error;
  }
};

export const saveNonDateBasedWorkoutExercise = (
  currentUser,
  index,
  submissionObject,
  dayNumber,
  errorAddReset,
  { onSuccess, onError } = {},
  assignedId = null,
) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_START,
    payload: { itemIndex: index },
  });

  const { selectedReduxNonDateBasedProgram, nonDateBasedProgramItems } = getState().calendar.data;

  const newValues = { ...submissionObject };

  let savedWorkoutId;
  if (Object.keys(selectedReduxNonDateBasedProgram).length) {
    savedWorkoutId = selectedReduxNonDateBasedProgram.id;
    newValues.savedWorkoutId = selectedReduxNonDateBasedProgram.id;
  }

  try {
    const response = await axiosAuthed.post(
      `/accounts/${currentUser.accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming`,
      newValues,
    );

    const exercises = nonDateBasedProgramItems[dayNumber]?.exercises || [];
    const originalExercises = [...exercises];
    const newOrderedAssignmentIds = [];

    originalExercises.forEach((item) => {
      /** non pre save item, presave items have an assigned id string that we create */
      if (typeof item.assignedId !== 'string') {
        newOrderedAssignmentIds.push(item.assignedId);
      }
    });

    newOrderedAssignmentIds.splice(index, 0, response.data.assignedId);

    const orderSubmissionObject = {
      dayNumber,
      order: newOrderedAssignmentIds,
    };

    /** we need to hit re order here because of pre saved items
     * we always need to account for them and make sure we are taking
     * them out of the saved order of items and make sure that when
     * we are saving an item we are saving it in the correct order
     */
    /** wait for ordering to complete */

    await dispatch(updateWorkoutItemsOrder(currentUser.accountCode, orderSubmissionObject, originalExercises));

    /** ordering is done, continue with success flow */
    dispatch({
      payload: {
        data: { ...response.data },
        itemIndex: index,
        dayNumber,
        preSwappedAssignedId: assignedId,
      },
      type: SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_FULFILLED,
    });

    // Clean up local state backup for the saved item
    if (assignedId) {
      dispatch(removePreSaveTableLocalState(assignedId));
    }

    if (onSuccess) onSuccess(response.data);

    dispatch(setLastUpdateTime());
  } catch (err) {
    showErrorToast(err?.response?.headers?.message || 'Unexpected error saving workout item');
    errorAddReset();

    dispatch({
      payload:
        err?.response?.headers?.message || 'Unexpected error saving workout item',
      type: SAVE_NON_DATE_BASED_WORKOUT_EXERCISE_REJECTED,
    });

    if (onError) onError(err.message);
  }
};

export const saveCalendarExercise = (
  currentUser,
  index,
  submissionObject,
  formattedDate,
  errorAddReset,
  { onSuccess, onError } = {},
  assignedId = null,
) => async (dispatch, getState) => {
  dispatch({
    type: SAVE_CALENDAR_EXERCISE_START,
    payload: { itemIndex: index },
  });

  const { selectedReduxCalendar, selectedReduxAthlete, calendarItems } = getState().calendar.data;

  const newValues = { ...submissionObject };

  /** Only strip the opposite key when we're about to set ours - so we never end up with neither */
  if (Object.keys(selectedReduxCalendar).length) {
    delete newValues.userId;
    newValues.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    delete newValues.calendarId;
    newValues.userId = selectedReduxAthlete.id;
  }

  try {
    const response = await axiosAuthed.post(
      `/accounts/${currentUser.accountCode}/calendars/programming`,
      newValues,
    );

    const datedCalendarItems = calendarItems[formattedDate]?.exercises || [];
    const originalItems = [...datedCalendarItems];

    /** Build full order (including strings - aka pre save items) */
    const newOrderedAssignmentIds = datedCalendarItems.map(
      (item) => item.assignedId,
    );

    /** Splice in the new assignedId at the correct index */
    newOrderedAssignmentIds.splice(index, 0, response.data.assignedId);

    /** Remove string IDs AFTER splice */
    const filteredOrderedAssignmentIds = newOrderedAssignmentIds.filter(
      (id) => typeof id !== 'string',
    );

    const orderSubmissionObject = {
      date: formattedDate,
      order: filteredOrderedAssignmentIds,
      assignedIdsBeingMoved: [response.data.assignedId],
      /** this index could be -1 if the item being moved is a pre save
       * item. It wouln't exist in the filteredOrder because we filtered them out
       * that is ok because we are handling this scenario in the
       * order action where we just return and don't hit the endpoint
       * if assignedIdsBeingMoved is empty because we filter assignedIdsBeingMoved in the action
       */
      movedToIndex: filteredOrderedAssignmentIds.indexOf(response.data.assignedId),
    };

    /** we need to hit re order here because of pre saved items
     * we always need to account for them and make sure we are taking
     * them out of the saved order of items
     */
    /** wait for ordering to complete */
    try {
      await dispatch(
        updateCalendarItemsOrder(
          currentUser.accountCode,
          orderSubmissionObject,
          originalItems,
        ),
      );
    } catch (reorderErr) {
      showErrorToast('Reorder failed');
    }

    /** ordering is done, continue with success flow */
    dispatch({
      payload: {
        data: { ...response.data },
        itemIndex: index,
        formattedDate,
        preSwappedAssignedId: assignedId,
      },
      type: SAVE_CALENDAR_EXERCISE_FULFILLED,
    });

    /** Clean up local state backup for the saved item */
    if (assignedId) {
      dispatch(removePreSaveTableLocalState(assignedId));
    }

    if (onSuccess) onSuccess(response.data);

    dispatch(setLastUpdateTime());
  } catch (err) {
    showErrorToast(err?.response?.headers?.message || 'Unexpected error saving calendar item');
    errorAddReset();

    dispatch({
      payload:
        err?.response?.headers?.message || 'Unexpected error saving calendar item',
      type: SAVE_CALENDAR_EXERCISE_REJECTED,
    });

    if (onError) onError(err.message);
  }
};

export const fetchCalWorkoutCalendar = (currentUser, userId, startDate, endDate, showHiddenItems = false) => (dispatch) => {
  dispatch({ type: FETCH_CAL_WORKOUT_CALENDAR_START });
  let route;
  if (currentUser.id === userId) {
    route = `/me/accounts/${currentUser.accountCode}`;
  } else {
    route = `/accounts/${currentUser.accountCode}/users/${userId}`;
  }
  axiosAuthed
    .get(
      `${route}/workouts/overview?dateRangeStart=${startDate}&dateRangeEnd=${endDate}${showHiddenItems ? '&showHiddenItems=true' : ''}`,
      {
        requestId: 'fetchWorkoutCalendar',
      },
    )
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_CAL_WORKOUT_CALENDAR_FULFILLED,
      });
    })
    .catch((thrown) => {
      if (axiosAuthed.isCancel(thrown)) {
        showErrorToast(thrown || 'Fetch calendar cancelled');
      } else {
        showErrorToast('An error has occurred fetching the workout calendar');
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred fetching the workout calendar');
      dispatch({
        payload:
            err?.response?.headers?.message
            || 'Unexpected error fetching workout calendar',
        type: FETCH_CAL_WORKOUT_CALENDAR_REJECTED,
      });
    });
};

export const setCalendarContainerScrollPositionTop = (positionNumberFromWindowTop) => (
  {
    type: SET_CALENDAR_CONTENT_SCROLL_CONTAINER_TOP_POSITION,
    payload: positionNumberFromWindowTop,
  }
);
export const setCalendarItems = (calendarItemsArray, date) => (
  {
    type: SET_CALENDAR_ITEMS,
    payload: { calendarItemsArray, date },
  }
);

export const setNonDateBasedProgramItems = (programItemsArray, programDayNumber) => (
  {
    type: SET_NON_DATE_BASED_PROGRAM_ITEMS,
    payload: { programItemsArray, programDayNumber },
  }
);

export const setNonDateBasedProgramDays = (programDays) => (
  {
    type: SET_NON_DATE_BASED_PROGRAM_DAYS,
    payload: { programDays },
  }
);

export const setRecurringCalendarItems = (calendarItemsArray, date, beforeOrAfter) => (
  {
    type: SET_RECURRING_CALENDAR_ITEMS,
    payload: { calendarItemsArray, date, beforeOrAfter },
  }
);

export const clearBeforeRecurringCalendarItems = () => (
  {
    type: CLEAR_BEFORE_RECURRING_CALENDAR_ITEMS,
  }
);

export const clearAfterRecurringCalendarItems = () => (
  {
    type: CLEAR_AFTER_RECURRING_CALENDAR_ITEMS,
  }
);
export const clearCalendarItems = () => (
  {
    type: CLEAR_CALENDAR_ITEMS,
  }
);
export const clearNonDateBasedProgramItems = () => (
  {
    type: CLEAR_NON_DATE_BASED_PROGRAM_ITEMS,
  }
);
export const setCombineWithInfo = (info) => (
  {
    type: SET_COMBINE_WITH_INFO,
    payload: info,
  }
);

export const setSideBarExerciseSearchTerm = (searchTerm) => (
  {
    type: SET_SIDE_BAR_EXERCISES_SEARCH_TERM,
    payload: searchTerm,
  }
);
export const setExercisePickerSearchTerm = (searchTerm) => (
  {
    type: SET_EXERCISE_PICKER_SEARCH_TERM,
    payload: searchTerm,
  }
);

export const setSuperSetPicker = (info) => (
  {
    type: SET_SUPERSET_PICKER,
    payload: info,
  }
);

export const addPreSavedItemToCalendarItemsArray = (
  item,
  date,
  destinationContainerIndex = null,
  droppableId = null,
) => (
  {
    type: ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY,
    payload: {
      item: { ...item, date }, date, destinationContainerIndex, droppableId,
    },
  }
);

export const addPreSavedItemToProgramItemsArray = (
  item,
  programDayNumber,
  destinationContainerIndex = null,
  droppableId = null,
) => (
  {
    type: ADD_PRESAVED_ITEM_TO_PROGRAM_ITEMS_ARRAY,
    payload: {
      item, programDayNumber: Number(programDayNumber), destinationContainerIndex, droppableId,
    },
  }
);

export const updateReduxCalendarItem = (
  item,
  date,
  destinationContainerIndex = null,
) => (
  {
    type: UPDATE_PRESAVED_CALENDAR_ITEM,
    payload: { item, date, destinationContainerIndex },
  }
);

export const updateReduxProgramItem = (
  item,
  programDayNumber,
  destinationContainerIndex = null,
) => (
  {
    type: UPDATE_PRESAVED_PROGRAM_ITEM,
    payload: { item, programDayNumber, destinationContainerIndex },
  }
);

export const setIsBeforeRecurringSectionExpanded = (bool) => (
  {
    type: SET_IS_BEFORE_RECURRING_SECTION_EXPANDED,
    payload: bool,
  }
);

export const setIsAfterRecurringSectionExpanded = (bool) => (
  {
    type: SET_IS_AFTER_RECURRING_SECTION_EXPANDED,
    payload: bool,
  }
);

export const setIsAthleteAddedItemsSectionExpanded = (bool) => (
  {
    type: SET_IS_ATHLETE_ADDED_ITEMS_SECTION_EXPANDED,
    payload: bool,
  }
);

export const setIsPrimaryAnimatedSideBarOpen = (bool) => (
  {
    type: SET_IS_PRIMARY_ANIMATED_SIDE_BAR_OPEN,
    payload: bool,
  }
);
export const setSwapDropdownToggleEnabled = (bool) => (
  {
    type: SET_SWAP_DROPDOWN_TOGGLE_ENABLED,
    payload: bool,
  }
);

export const setPrimarySideBarDataTag = (dataTag) => (
  {
    type: SET_PRIMARY_SIDE_BAR_DATA_TAG,
    payload: dataTag,
  }
);

export const setSecondarySideBarDataTag = (dataTag) => (
  {
    type: SET_SECONDARY_SIDE_BAR_DATA_TAG,
    payload: dataTag,
  }
);
/** can add modal data as an object of whatever data you want to pass to the modal */
export const setActiveModal = (modalType, modalData = null) => (
  {
    type: SET_ACTIVE_MODAL,
    payload: { modalType, modalData },
  }
);

export const setActiveSecondLayerModal = (modalType) => (
  {
    type: SET_ACTIVE_SECOND_LAYER_MODAL,
    payload: modalType,
  }
);

export const setAddInfoContent = (content) => (
  {
    type: SET_ADD_INFO_CONTENT,
    payload: content,
  }
);

export const clearNewlyCreatedQuestion = () => ({
  type: CLEAR_NEWLY_CREATED_QUESTION,
});

export const setQuestionCount = (questions) => (
  {
    type: SET_QUESTION_COUNT,
    payload: questions,
  }
);

export const setSelectedItems = (items) => (
  {
    type: SET_SELECTED_ITEMS,
    payload: items,
  }
);

export const setSelectedItem = (item) => (
  {
    type: SET_SELECTED_ITEM,
    payload: item,
  }
);

export const removeSelectedItem = (item) => (
  {
    type: REMOVE_SELECTED_ITEM,
    payload: item,
  }
);

export const copySelectedItemsToClipboard = () => (dispatch, getState) => {
  const {
    selectedItems,
    selectedDate,
    weekViewExpandedDay,
    viewType,
    programType,
    selectedReduxCalendar,
    selectedReduxAthlete,
  } = getState().calendar.data;

  // Guard: only allow in day view, week view, and non-free-form-program
  if ((viewType !== 'dayView' && viewType !== 'weekView') || programType === 'free-form-program') {
    return;
  }

  // Guard: no items selected
  const itemCount = Object.keys(selectedItems).length;
  if (itemCount === 0) {
    return;
  }

  // Guard: weekView requires an expanded day to determine source date
  if (viewType === 'weekView' && !weekViewExpandedDay) {
    return;
  }

  // Guard: dayView requires a valid selectedDate
  if (viewType === 'dayView' && !selectedDate) {
    return;
  }

  // Determine source date based on view type
  let sourceDate;
  if (viewType === 'weekView') {
    sourceDate = weekViewExpandedDay; // Already in YYYY-MM-DD format
  } else {
    sourceDate = moment(selectedDate).format('YYYY-MM-DD');
  }

  // Filter selected items to only those from the source date
  const { calendarItems } = getState().calendar.data;
  const dayExercises = calendarItems[sourceDate]?.exercises || [];
  const dayAssignedIds = new Set(
    dayExercises.map((ex) => ex.assignedId),
  );
  const filteredItems = {};
  Object.entries(selectedItems).forEach(([key, item]) => {
    if (dayAssignedIds.has(item.assignedId)) {
      filteredItems[key] = item;
    }
  });

  const filteredCount = Object.keys(filteredItems).length;
  if (filteredCount === 0) {
    showErrorToast('No selected items found for this day');
    return;
  }

  // Store filtered items with source date and source context
  dispatch({
    type: SET_COPIED_SELECTED_ITEMS,
    payload: {
      items: filteredItems,
      sourceDate,
      programType,
      sourceCalendar: selectedReduxCalendar,
      sourceAthlete: selectedReduxAthlete,
    },
  });

  // Show success toast with accurate count
  showSuccessToast(`${filteredCount} item${filteredCount === 1 ? '' : 's'} copied`);
};

export const setExpandedItems = (items) => (
  {
    type: SET_EXPANDED_ITEMS,
    payload: items,
  }
);

export const setExpandedItem = (item) => (
  {
    type: SET_EXPANDED_ITEM,
    payload: item,
  }
);

export const removeExpandedItem = (item) => (
  {
    type: REMOVE_EXPANDED_ITEM,
    payload: item,
  }
);

export const setWeekViewExpandedDay = (dayKey) => (
  {
    type: SET_WEEK_VIEW_EXPANDED_DAY,
    payload: dayKey,
  }
);

export const focusNextPreSaveItem = (currentIndex, selectedDate) => (
  {
    type: FOCUS_NEXT_PRESAVE_ITEM,
    payload: { currentIndex, selectedDate },
  }
);

export const focusNextPreSaveProgramItem = (currentIndex, dayNumber) => (
  {
    type: FOCUS_NEXT_PRESAVE_PROGRAM_ITEM,
    payload: { currentIndex, dayNumber },
  }
);

export const setSelectedReduxCalendar = (calendar) => (
  {
    type: SET_SELECTED_REDUX_CALENDAR,
    payload: calendar,
  }
);

export const setSelectedReduxAthlete = (athlete) => (
  {
    type: SET_SELECTED_REDUX_ATHLETE,
    payload: athlete,
  }
);

export const setDeleteStack = (deleteStack) => (
  {
    type: SET_DELETE_STACK,
    payload: deleteStack,
  }
);

export const setProgrammedCalendarItems = (programmedCalendarItems) => (
  {
    type: SET_PROGRAMMED_CALENDAR_ITEMS,
    payload: programmedCalendarItems,
  }
);

export const removePresaveItemFromRedux = (date, index, assignedId) => (
  {
    type: REMOVE_PRESAVE_ITEM_FROM_REDUX,
    payload: {
      date,
      index,
      assignedId,
    },
  }
);

export const removePresaveProgramItemFromRedux = (dayNumber, index, assignedId) => (
  {
    type: REMOVE_PRESAVE_PROGRAM_ITEM_FROM_REDUX,
    payload: {
      dayNumber,
      index,
      assignedId,
    },
  }
);

export const setSelectedDate = (date) => (
  {
    type: SET_SELECTED_DATE,
    payload: date,
  }
);

export const setSelectedStartDayOfWeek = (dayName) => (
  {
    type: SET_SELECTED_START_DAY_OF_WEEK,
    payload: dayName,
  }
);

export const setSelectedWeekViewDayToggle = (option) => (
  {
    type: SET_SELECTED_WEEK_VIEW_DAY_TOGGLE,
    payload: option,
  }
);

export const setCurrentlyDisplayedWeekdays = (weekDays) => (
  {
    type: SET_CURRENTLY_DISPLAYED_WEEKDAYS,
    payload: weekDays,
  }
);

export const setSelectedNumberOfDaysToShowInWeek = (numberOfDays) => (
  {
    type: SET_SELECTED_NUMBER_OF_DAYS_TO_SHOW_IN_WEEK,
    payload: numberOfDays,
  }
);
export const setGroupByFilter = (option) => (
  {
    type: SET_GROUP_BY_FILTER,
    payload: option,
  }
);

export const setSelectedDaysOfWeekToShowInCurrentWeek = (dayNamesToShow) => (
  {
    type: SET_SELECTED_DAYS_OF_WEEK_TO_SHOW_IN_CURRENT_WEEK,
    payload: dayNamesToShow,
  }
);

export const setSelectedMonth = (month) => (
  {
    type: SET_SELECTED_MONTH,
    payload: month,
  }
);
export const setFirstMonthInPicker = (month) => (
  {
    type: SET_FIRST_MONTH_IN_PICKER,
    payload: month,
  }
);

export const setNewPreSaveItemFromCreateExerciseForm = (item) => (
  {
    type: SET_NEW_PRESAVE_ITEM_FROM_CREATE_EXERCISE_FORM,
    payload: item,
  }
);

export const setIsCloneDragging = (bool) => (
  {
    type: SET_IS_CLONE_DRAGGING,
    payload: bool,
  }
);

export const setOnBeforeCapture = (bool) => (
  {
    type: SET_ON_BEFORE_CAPTURE,
    payload: bool,
  }
);

export const setCombineWithId = (id) => (
  {
    type: SET_COMBINE_WITH_ID,
    payload: id,
  }
);

export const setCalendarPanelContainerWidth = (width) => (
  {
    type: SET_CALENDAR_PANEL_CONTAINER_WIDTH,
    payload: width,
  }
);
export const setAnimatedSidebarContainerWidth = (width) => (
  {
    type: SET_ANIMATED_SIDEBAR_CONTAINER_WIDTH,
    payload: width,
  }
);

export const setHeaderHeight = (height) => (
  {
    type: SET_HEADER_HEIGHT,
    payload: height,
  }
);

export const setIsDragging = (bool) => (
  {
    type: SET_IS_DRAGGING,
    payload: bool,
  }
);

export const setDragSource = (dragSource) => (
  {
    type: SET_DRAG_SOURCE,
    payload: dragSource,
  }
);

export const setPlaceholderInfo = (info) => (
  {
    type: SET_PLACEHOLDER_INFO,
    payload: info,
  }
);
export const setDragIsInProgress = (bool) => (
  {
    type: SET_DRAG_IS_IN_PROGRESS,
    payload: bool,
  }
);

export const setDroppableContainerCurrentlyHoveredByDraggedItem = (droppableId) => (
  {
    type: SET_DROPPABLE_CONTAINER_CURRENTLY_HOVERED_BY_DRAGGED_ITEM,
    payload: droppableId,
  }
);

export const setDraggedItem = (dragSource) => (
  {
    type: SET_DRAGGED_ITEM,
    payload: dragSource,
  }
);

export const setReduxCalendarContainers = (reduxCalendarContainers) => (
  {
    type: SET_REDUX_CALENDAR_CONTAINERS,
    payload: reduxCalendarContainers,
  }
);

export const setIframelyError = (error) => (
  {
    type: SET_IFRAMELY_ERROR,
    payload: error,
  }
);

export const logReduxPresaveAddInfo = (id, content) => (
  {
    type: LOG_REDUX_PRESAVE_ADD_INFO,
    payload: {
      id,
      content,
    },
  }
);

export const logReduxPresaveDescription = (id, content) => (
  {
    type: LOG_REDUX_PRESAVE_DESCRIPTION,
    payload: {
      id,
      content,
    },
  }
);

export const addAsset = (asset) => (
  {
    type: ADD_ASSET,
    payload: asset,
  }
);

export const setClickedUpgradeNow = (bool) => (
  {
    type: SET_CLICKED_UPGRADE_NOW,
    payload: bool,
  }
);

export const setCalendarContainerScrollPosition = (position) => (
  {
    type: SET_CALENDAR_CONTAINER_SCROLL_POSITION,
    payload: position,
  }
);

export const toggleAnalyticsStrikethrough = () => ({
  type: TOGGLE_ANALYTICS_STRIKETHROUGH,
});

/**
 * Fetches an array of all exercises for the given account code
 */
export const fetchAllExercisesForAccount = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_ALL_EXERCISES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/exercises?includeHealthItems=true`)
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_ALL_EXERCISES_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred fetching exercises');
      dispatch({
        payload: err.response.headers.message,
        type: FETCH_ALL_EXERCISES_REJECTED,
      });
    });
};

export const fetchExerciseForAccount = (accountCode, exerciseId) => (dispatch) => {
  dispatch({ type: FETCH_EXERCISE_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/exercises/${exerciseId}`)
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_EXERCISE_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred fetching the exercise');
      dispatch({
        payload: err.response.headers.message,
        type: FETCH_EXERCISE_REJECTED,
      });
    });
};

/** upload media endpoints */

export const uploadMedia = (accountCode, file, fileType, { onSuccess, onError } = {}) => (
  (dispatch) => {
    const formData = new FormData();
    formData.append(fileType, file);
    dispatch({ type: UPLOAD_CALENDAR_MEDIA_START });
    axiosAuthed.post(`/accounts/${accountCode}/media/upload/VIDEO`, formData)
      .then((response) => {
        dispatch({ type: UPLOAD_CALENDAR_MEDIA_FULFILLED, payload: response.data });
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((err) => {
        dispatch({ type: UPLOAD_CALENDAR_MEDIA_REJECTED, payload: err.message });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

export const editThumbnail = (
  accountCode,
  file,
  fileType,
  mediaId,
  { onSuccess, onError } = {},
) => (
  (dispatch) => {
    const formData = new FormData();
    formData.append(fileType, file);
    dispatch({ type: EDIT_THUMBNAIL_START });
    axiosAuthed.put(`/accounts/${accountCode}/media/${mediaId}/thumbnail`, formData).then((response) => {
      dispatch({
        type: EDIT_THUMBNAIL_FULFUILLED,
        payload: response.data,
      });
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
      .catch((err) => {
        dispatch({
          type: EDIT_THUMBNAIL_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

export const uploadMediaUrl = (mediaUrl, accountCode, { onSuccess, onError } = {}) => (
  (dispatch) => {
    const formData = new FormData();
    formData.append('url', mediaUrl);
    dispatch({ type: UPLOAD_MEDIA_BY_URL_START });
    axiosAuthed.post(`/accounts/${accountCode}/media/upload/EXTERNAL_URL`, formData)
      .then((response) => {
        dispatch({
          type: UPLOAD_MEDIA_BY_URL_FULFILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((err) => {
        dispatch({
          type: UPLOAD_MEDIA_BY_URL_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

// export const uploadWorkoutsMedia = (values) => (
//   (dispatch) => {
//     const formData = new FormData();
//     formData.append(values.type, values.acceptedFile[0]);
//     dispatch({ type: UPLOAD_WORKOUTS_MEDIA_START });
//     axiosAuthed.post(`/media/upload/${values.type}`, formData).then((response) => {
//       dispatch({
//         type: UPLOAD_WORKOUTS_MEDIA_FULFILLED,
//         payload: response.data,
//       });
//     })
//       .catch((err) => {
//         dispatch({
//           type: UPLOAD_WORKOUTS_MEDIA_REJECTED,
//           payload: err,
//         });
//       });
//   }
// );

export const createExercise = (accountCode, values, { onSuccess, onError } = {}) => (
  dispatch,
) => {
  dispatch({ type: CREATE_EXERCISE_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/exercises`, values)
    .then((response) => {
      setTimeout(() => {
        showSuccessToast('Exercise created');
        dispatch({
          type: CREATE_EXERCISE_FULFILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      }, 500);
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred creating an exercise');
      dispatch({
        type: CREATE_EXERCISE_REJECTED,
        payload: err,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

/** Documents */
export const fetchDocuments = (accountCode, { onSuccess, onError } = {}) => (
  (dispatch) => {
    dispatch({ type: FETCH_DOCUMENTS_START });
    axiosAuthed.get(`/accounts/${accountCode}/documents`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_DOCUMENTS_FULFILLED,
            payload: response.data,
          });
          if (onSuccess) {
            onSuccess(response.data);
          }
        }, 750);
      })
      .catch((err) => {
        dispatch({
          type: FETCH_DOCUMENTS_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

export const fetchDocument = (values, { onSuccess, onError } = {}) => (
  (dispatch) => {
    dispatch({ type: FETCH_DOCUMENT_START });
    axiosAuthed.get(`/accounts/${values.accountCode}/documents/${values.docId}`)
      .then((response) => {
        dispatch({
          type: FETCH_DOCUMENT_FULFILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((err) => {
        dispatch({
          type: FETCH_DOCUMENT_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

export const fetchFolder = (values, { onSuccess, onError } = {}) => (
  (dispatch) => {
    dispatch({ type: FETCH_FOLDER_START });
    axiosAuthed.get(`/accounts/${values.accountCode}/documents/?folderId=${values.folderId}`)
      .then((response) => {
        setTimeout(() => {
          dispatch({
            type: FETCH_FOLDER_FULFILLED,
            payload: response.data,
          });
          if (onSuccess) {
            onSuccess(response.data);
          }
        }, 750);
      })
      .catch((err) => {
        dispatch({
          type: FETCH_FOLDER_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err.message);
        }
      });
  }
);

export const fetchAthletes = (accountCode) => (dispatch) => {
  dispatch({ type: FETCH_CALENDAR_SELECT_ATHLETES_START });
  axiosAuthed
    .get(`/accounts/${accountCode}/athlete-calendars`)
    .then((response) => {
      dispatch({
        payload: response.data,
        type: FETCH_CALENDAR_SELECT_ATHLETES_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred fetching athletes');
      dispatch({
        payload: err,
        type: FETCH_CALENDAR_SELECT_ATHLETES_REJECTED,
      });
    });
};

export const getProgrammedCalendarItem = (accountCode, assignedId) => (
  (dispatch) => {
    dispatch({ type: FETCH_PROGRAMMED_CALENDAR_ITEM_START });
    axiosAuthed.get(`/accounts/${accountCode}/calendars/programming/${assignedId}`)
      .then((response) => {
        dispatch({
          type: FETCH_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_PROGRAMMED_CALENDAR_ITEM_REJECTED,
          payload: err,
        });
      });
  }
);

export const updateSavedWorkoutItem = (accountCode, values, index, dayNumber, reorder = false, { onSuccess, onError } = {}) => async (dispatch, getState) => {
  const { selectedReduxNonDateBasedProgram } = getState().calendar.data;

  const newValues = { ...values };

  newValues.isRecurring = false;
  newValues.date = '';

  if (Object.keys(selectedReduxNonDateBasedProgram).length) {
    newValues.savedWorkoutId = selectedReduxNonDateBasedProgram.id;
  }

  dispatch({
    type: UPDATE_SAVED_WORKOUT_ITEM_START,
    payload: { itemIndex: index },
  });

  try {
    const response = await axiosAuthed
      .put(`/accounts/${accountCode}/workouts/saved-workouts/${newValues.savedWorkoutId}/programming/${values.assignedId}`, newValues);

    dispatch({
      type: UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
      payload: {
        data: response.data,
        itemIndex: index,
        dayNumber,
        isRecurring: false,
      },
    });

    if (reorder && !newValues.isRecurring) {
    /** we need to reorder on update to catch updated order of super set items
     * we should also make sure we are staying up to date with order whenever there is an update
     * because of debounced calls we would accidentally skip a reorder if the user
     * combines and then makes another update in the debounce window
     */
      const { nonDateBasedProgramItems } = getState().calendar.data;
      const programItems = nonDateBasedProgramItems[dayNumber].exercises;
      const newOrderedAssignmentIds = [];
      programItems.forEach((programItem) => {
        if (typeof programItem.assignedId !== 'string') {
          newOrderedAssignmentIds.push(programItem.assignedId);
        }
      });
      const orderSubmissionObject = {
        dayNumber,
        order: newOrderedAssignmentIds,
      };
      await dispatch(updateWorkoutItemsOrder(accountCode, orderSubmissionObject));
    }

    dispatch(setLastUpdateTime());
    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (err) {
    showErrorToast(err?.response?.headers?.message || 'An error has occurred updating the workout');

    /** Attempt to revert item using original data from GET */
    /** we need to to this because sometimes we update things physically (in state) before they are successfully returned from the endpoint
     * and that redux change is what triggers the endpoint call
     * we do this to keep consistent with pre saved items and deboucne logic
     */
    try {
      const getResponse = await axiosAuthed.get(
        `/accounts/${accountCode}/workouts/saved-workouts/${newValues.savedWorkoutId}/programming/${values.assignedId}`,
      );

      /** Use GET response to overwrite the reducer with original item */
      dispatch({
        type: UPDATE_SAVED_WORKOUT_ITEM_FULFILLED,
        payload: {
          data: getResponse.data,
          itemIndex: index,
          dayNumber,
          isRecurring: false,
          reverted: true, /** optional: add a flag to detect reversion if needed */
        },
      });
    } catch (getErr) {
      console.error('Failed to fetch original item after update failure', getErr);
    }

    /** Always treat the update as a failure */
    dispatch({
      type: UPDATE_SAVED_WORKOUT_ITEM_REJECTED,
      payload: err,
    });

    if (onError) {
      onError(err?.response?.headers?.message);
    }
  }
};

export const updateProgrammedCalendarItem = (accountCode, values, index, formattedDate, reorder = false, { onSuccess, onError } = {}) => async (dispatch, getState) => {
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  const newValues = { ...values };

  /** Always remove dayNumber if it exists */
  delete newValues.dayNumber;

  /** Only strip the opposite key when we're about to set ours - so we never end up with neither */
  if (Object.keys(selectedReduxCalendar).length) {
    delete newValues.userId;
    newValues.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    delete newValues.calendarId;
    newValues.userId = selectedReduxAthlete.id;
  }

  if (values.isRecurring) {
    newValues.date = '0000-00-00';
  }

  // Build request body with assignment and futureOccurrencesSettings
  const requestBody = newValues;
  dispatch({
    type: UPDATE_PROGRAMMED_CALENDAR_ITEM_START,
    payload: { itemIndex: index },
  });

  try {
    const response = await axiosAuthed
      .put(`/accounts/${accountCode}/calendars/programming/${values.assignedId}`, requestBody);
    dispatch({
      type: UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
      payload: {
        data: response.data,
        itemIndex: index,
        formattedDate,
        isRecurring: values.isRecurring,
      },
    });

    if (reorder && !values.isRecurring) {
    /** we need to reorder on update to catch updated order of super set items
     * we should also make sure we are staying up to date with order whenever there is an update
     * because of debounced calls we would accidentally skip a reorder if the user
     * combines and then makes another update in the debounce window
     */
      const { calendarItems } = getState().calendar.data;
      const datedCalendarItems = calendarItems[formattedDate].exercises;
      const newOrderedAssignmentIds = [];
      datedCalendarItems.forEach((calendarItem) => {
        /** filter out string ids - pre save items are string ids */
        if (typeof calendarItem.assignedId !== 'string') {
          newOrderedAssignmentIds.push(calendarItem.assignedId);
        }
      });
      const orderSubmissionObject = {
        date: formattedDate,
        order: newOrderedAssignmentIds,
        assignedIdsBeingMoved: [values.assignedId],
        /** this index could be -1 if the item being moved is a pre save
       * item. It wouln't exist in the filteredOrder because we filtered them out
       * that is ok because we are handling this scenario in the
       * order action where we just return and don't hit the endpoint
       * if assignedIdsBeingMoved is empty because we filter assignedIdsBeingMoved in the action
       */
        movedToIndex: newOrderedAssignmentIds.indexOf(values.assignedId),
      };
      await dispatch(updateCalendarItemsOrder(accountCode, orderSubmissionObject));
    }

    dispatch(setLastUpdateTime());
    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (err) {
    showErrorToast(err?.response?.headers?.message || 'An error has occurred updating the workout', {
      toastId: 'update-calendar-item-error', /** same ID prevents duplicates */
    });

    /** Attempt to revert item using original data from GET */
    /** we need to to this because sometimes we update things physically (in state) before they are successfully returned from the
     * and that change is what triggers the endpoint call
     * we due this to keep consistent with pre saved items and deboucne logic
     */
    try {
      const getResponse = await axiosAuthed.get(
        `/accounts/${accountCode}/calendars/programming/${values.assignedId}`,
      );

      /** Use GET response to overwrite the reducer with original item */
      dispatch({
        type: UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
        payload: {
          data: getResponse.data,
          itemIndex: index,
          formattedDate,
          isRecurring: values.isRecurring,
          reverted: true, /** optional: add a flag to detect reversion if needed */
        },
      });
    } catch (getErr) {
      console.error('Failed to fetch original item after update failure', getErr);
    }

    /** Always treat the update as a failure */
    dispatch({
      type: UPDATE_PROGRAMMED_CALENDAR_ITEM_REJECTED,
      payload: err,
    });

    if (onError) {
      onError(err?.response?.headers?.message);
    }
  }
};

export const updateFutureOccurrencesProgrammedCalendarItem = (accountCode, values, formattedDate, id, isTags, { onSuccess, onError } = {}) => async (dispatch, getState) => {
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  const newValues = { ...values };

  // Extract top-level fields
  const {
    originalExerciseId,
    startDate,
    endDate,
    updateExercise,
    updateSets,
    updateAdvancedInfo,
  } = newValues;

  // Remove fields that go at top level (not in assignment)
  delete newValues.originalExerciseId;
  delete newValues.startDate;
  delete newValues.endDate;
  delete newValues.updateExercise;
  delete newValues.updateSets;
  delete newValues.updateAdvancedInfo;
  delete newValues.dayNumber;

  /** Defensive: strip only when BOTH ids are present (the leak signature from spread chains).
   * Single deliberate id passes through untouched (modal sets assignment.calendarId = parentId for inherited items).
   *  - inherited: assignment lives on the parent calendar → calendarId is the parentId, keep it
   *  - non-inherited: assignment lives on the user → keep userId */
  if (newValues.calendarId && newValues.userId) {
    if (newValues.isInherited) {
      delete newValues.userId;
    } else {
      delete newValues.calendarId;
    }
  }

  // Determine top-level calendarId or userId (independent of the assignment's own id)
  let calendarId;
  let userId;

  if (Object.keys(selectedReduxCalendar).length) {
    calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    userId = selectedReduxAthlete.id;
  }

  // Add the date to assignment
  newValues.date = formattedDate;

  // Build request body with new schema
  const requestBody = {
    assignment: newValues,
    exerciseId: originalExerciseId,
    startDate,
    updateExercise,
    updateSets,
    updateAdvancedInfo,
  };

  // Add optional endDate if provided
  if (endDate) {
    requestBody.endDate = endDate;
  }

  // Add calendarId or userId
  if (calendarId) {
    requestBody.calendarId = calendarId;
  } else if (userId) {
    requestBody.userId = userId;
  }

  dispatch({
    type: UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_START,
  });

  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/calendars/programming/${values.assignedId}/future-occurrences`,
      requestBody,
    );

    showSuccessToast('Future occurrences updated successfully');

    dispatch({
      type: UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
      payload: {
        data: response.data,
        formattedDate,
      },
    });

    // Refresh calendar data after bulk update
    const { auth, calendar } = getState();
    const { currentUser } = auth.data;
    const { selectedDate } = calendar.data;
    const reduxDate = moment(selectedDate);

    // Calculate date range for refetch (current month + next month)
    const currentMonthStart = reduxDate.clone().startOf('month');
    const nextMonthEnd = reduxDate.clone().add(1, 'month').endOf('month');
    const currentAndNextMonthDays = nextMonthEnd.diff(currentMonthStart, 'days') + 1;
    const maxPreviousDays = Math.max(0, 69 - currentAndNextMonthDays);
    const fetchStartDate = currentMonthStart.clone().subtract(maxPreviousDays, 'days');

    const firstDayMonth = fetchStartDate.format('YYYY-MM-DD');
    const lastDayMonth = nextMonthEnd.format('YYYY-MM-DD');

    // Refetch calendar items
    if (Object.keys(selectedReduxCalendar).length && Object.keys(currentUser).length) {
      if (selectedReduxCalendar?.id) {
        dispatch(getAssignedWorkoutItemsForCalendarByDate(
          currentUser,
          firstDayMonth,
          lastDayMonth,
          selectedReduxCalendar.id,
        ));
      }
    } else if (Object.keys(selectedReduxAthlete).length && Object.keys(currentUser).length) {
      dispatch(getAssignedWorkoutItemsForAthleteByDate(
        currentUser,
        firstDayMonth,
        lastDayMonth,
        selectedReduxAthlete.id,
      ));
    }

    dispatch(setLastUpdateTime());

    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (err) {
    showErrorToast(
      err?.response?.headers?.message || 'An error occurred updating future occurrences',
      { toastId: 'update-future-occurrences-error' },
    );

    dispatch({
      type: UPDATE_FUTURE_OCCURRENCES_PROGRAMMED_CALENDAR_ITEM_REJECTED,
      payload: err,
    });

    if (onError) {
      onError(err?.response?.headers?.message);
    }
  }
};

export const fetchFutureOccurrencesCount = (
  accountCode,
  assignedId,
  exerciseId,
  startDate,
  endDate = null,
) => async (dispatch, getState) => {
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  dispatch({
    type: FETCH_FUTURE_OCCURRENCES_COUNT_START,
  });

  const requestBody = {
    exerciseId,
    startDate,
  };

  if (endDate) {
    requestBody.endDate = endDate;
  }

  let userId;
  let calendarId;

  if (Object.keys(selectedReduxCalendar).length) {
    calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    userId = selectedReduxAthlete.id;
  }

  // Add calendarId or userId
  if (calendarId) {
    requestBody.calendarId = calendarId;
  } else if (userId) {
    requestBody.userId = userId;
  }

  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/calendars/programming/${assignedId}/future-occurrences-check`,
      requestBody,
    );

    dispatch({
      type: FETCH_FUTURE_OCCURRENCES_COUNT_FULFILLED,
      payload: {
        count: response.data.count,
      },
    });

    return response.data.count;
  } catch (err) {
    // Silent failure - no toast
    console.error('Failed to fetch future occurrences count:', err);

    dispatch({
      type: FETCH_FUTURE_OCCURRENCES_COUNT_REJECTED,
      payload: err,
    });

    return null;
  }
};

export const swapProgrammedItemOnChildCalendar = (accountCode, values, index, formattedDate, reorder = false, { onSuccess, onError } = {}) => async (dispatch, getState) => {
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  const newValues = { ...values };

  /** Always remove dayNumber if it exists - calendar swap requests must not carry it */
  delete newValues.dayNumber;

  /** Defensive: strip only when BOTH ids are present (the leak signature from spread chains).
   * Single deliberate id passes through untouched.
   *  - inherited: assignment lives on the parent calendar → calendarId is the parentId, keep it
   *  - non-inherited: assignment lives on the user → keep userId */
  if (newValues.calendarId && newValues.userId) {
    if (newValues.isInherited) {
      delete newValues.userId;
    } else {
      delete newValues.calendarId;
    }
  }

  const requestBody = {
    assignment: newValues,
  };

  if (Object.keys(selectedReduxCalendar).length) {
    requestBody.childCalendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    requestBody.userCalendarId = selectedReduxAthlete.id;
  }

  dispatch({
    type: SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_START,
    payload: { itemIndex: index },
  });

  try {
    const response = await axiosAuthed.post(
      `/accounts/${accountCode}/calendars/programming/${values.assignedId}/swap`,
      requestBody,
    );

    showSuccessToast('Calendar updated');

    dispatch({
      type: SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_FULFILLED,
      payload: {
        data: { ...response.data },
        itemIndex: index,
        formattedDate,
        preSwappedAssignedId: values.assignedId,
      },
    });

    /** I'm removing the check for reorder to accommodate updates to the new backend reorder system
     * the back end needs us to call reorder after swap every time. I'm commmenting this out for now
     */

    /** if (reorder) { */

    /** we need to reorder on update to catch updated order of super set items
     * we should also make sure we are staying up to date with order whenever there is an update
     * because of debounced calls we would accidentally skip a reorder if the user
     * combines and then makes another update in the debounce window
     */
    const { calendarItems } = getState().calendar.data;
    const datedCalendarItems = calendarItems[formattedDate].exercises;
    const itemsOnDateUseLegacyOrder = calendarItems[formattedDate]?.itemsOnDateUseLegacyOrder;
    const originalItems = [...datedCalendarItems];
    const newOrderedAssignmentIds = [];
    datedCalendarItems.forEach((calendarItem) => {
      /** filter out string ids - pre save items are string ids */
      if (typeof calendarItem.assignedId !== 'string') {
        newOrderedAssignmentIds.push(calendarItem.assignedId);
      }
    });

    const preSwappedAssingedId = values.assignedId;
    const newAssignedId = response?.data?.assignedId;

    const orderSubmissionObject = {
      date: formattedDate,
      /** if itemsOnDateUseLegacyOrder is false, then we need to also include the preSwappedAssigedId in the payload */
      order: !itemsOnDateUseLegacyOrder ? [...newOrderedAssignmentIds, preSwappedAssingedId] : newOrderedAssignmentIds,
      assignedIdsBeingMoved: [newAssignedId],
      /** this index could be -1 if the item being moved is a pre save
       * item. It wouln't exist in the filteredOrder because we filtered them out
       * that is ok because we are handling this scenario in the
       * order action where we just return and don't hit the endpoint
       * if assignedIdsBeingMoved is empty because we filter assignedIdsBeingMoved in the action
       */
      movedToIndex: newOrderedAssignmentIds.indexOf(newAssignedId),
    };
    await dispatch(updateCalendarItemsOrder(accountCode, orderSubmissionObject, originalItems));

    /** closing bracket for commented out reorder check */
    /** } */

    dispatch(setLastUpdateTime());
    if (onSuccess) {
      onSuccess(response.data);
    }
  } catch (err) {
    showErrorToast(err?.response?.headers?.message || 'An error has occurred updating the workout');

    /** Attempt to revert item using original data from GET */
    /** we need to to this because sometimes we update things physically (in state) before they are successfully returned from the
   * and that change is what triggers the endpoint call
   * we due this to keep consistent with pre saved items and deboucne logic
   */
    try {
      const getResponse = await axiosAuthed.get(
        `/accounts/${accountCode}/calendars/programming/${values.assignedId}`,
      );

      /** Use GET response to overwrite the reducer with original item */
      dispatch({
        type: UPDATE_PROGRAMMED_CALENDAR_ITEM_FULFILLED,
        payload: {
          data: getResponse.data,
          itemIndex: index,
          formattedDate,
          isRecurring: values.isRecurring,
          reverted: true, /** optional: add a flag to detect reversion if needed */
        },
      });
    } catch (getErr) {
      console.error('Failed to fetch original item after update failure', getErr);
    }

    /** Always treat the update as a failure */
    dispatch({
      type: SWAP_PROGRAMMED_ITEM_ON_CHILD_CALENDAR_REJECTED,
      payload: err,
    });
    if (onError) {
      onError(err?.response?.headers?.message);
    }
  }
};

export const revertSwappedItemToParent = (accountCode, assignedId, index, formattedDate, { onSuccess, onError } = {}) => (
  dispatch,
) => {
  dispatch({
    type: REVERT_SWAPPED_ITEM_START,
    payload: { itemIndex: index },
  });
  axiosAuthed
    .post(`/accounts/${accountCode}/calendars/programming/${assignedId}/revert`)
    .then((response) => {
      showSuccessToast('Exercise reverted');
      dispatch({
        type: REVERT_SWAPPED_ITEM_FULFILLED,
        payload: {
          data: { ...response.data },
          itemIndex: index,
          formattedDate,
          preRevertedAssignedId: assignedId,
        },
      });
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred reverting swapped exercise');
      dispatch({
        type: REVERT_SWAPPED_ITEM_REJECTED,
        payload: err,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

export const createTagForAccount = (accountCode, tagName, { onSuccess, onError } = {}) => (
  dispatch,
) => {
  dispatch({ type: CREATE_TAG_FOR_ACCOUNT_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/tags`, { name: tagName })
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: CREATE_TAG_FOR_ACCOUNT_FULTILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      }, 750);
    })
    .catch((err) => {
      dispatch({
        type: CREATE_TAG_FOR_ACCOUNT_REJECTED,
        payload: err,
      });
      if (onError) {
        onError(err?.response?.headers?.message);
      }
    });
};

export const fetchTagsForAccount = (accountCode, { onSuccess, onError } = {}) => (
  (dispatch) => {
    dispatch({ type: FETCH_ACCOUNT_TAGS_START });
    axiosAuthed.get(`/accounts/${accountCode}/tags`)
      .then((response) => {
        dispatch({
          type: FETCH_ACCOUNT_TAGS_FULFILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((err) => {
        dispatch({
          type: FETCH_ACCOUNT_TAGS_REJECTED,
          payload: err,
        });
        if (onError) {
          onError(err);
        }
      });
  }
);

export const fetchQuestionsForAccount = (accountCode) => (
  (dispatch) => {
    dispatch({ type: FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_START });
    axiosAuthed.get(`/accounts/${accountCode}/questions`)
      .then((response) => {
        dispatch({
          type: FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: FETCH_QUESTIONS_FOR_ACCOUNT_CALENDAR_REJECTED,
          payload: err,
        });
      });
  }
);

export const createQuestionForAccount = (accountCode, values, { onSuccess, onError } = {}) => (
  dispatch,
) => {
  dispatch({ type: CREATE_QUESTION_FOR_ACCOUNT_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/questions`, values)
    .then((response) => {
      setTimeout(() => {
        dispatch({
          type: CREATE_QUESTION_FOR_ACCOUNT_FULTILLED,
          payload: response.data,
        });
        if (onSuccess) {
          onSuccess(response.data);
        }
      }, 750);
    })
    .catch((err) => {
      dispatch({
        type: CREATE_QUESTION_FOR_ACCOUNT_REJECTED,
        payload: err,
      });
      if (onError) {
        onError(err?.response?.headers?.message);
      }
    });
};

export const setSelectedSavedWorkout = (workout) => ({
  type: SET_SELECTED_SAVED_WORKOUT,
  payload: workout,
});

export const setIsCalendarOptionsDropdownMenuOpen = (bool) => ({
  type: SET_IS_CALENDAR_OPTIONS_DROPDOWN_MENU_OPEN,
  payload: bool,
});

export const setIsStaticAddColumnDropdownMenuOpen = (bool) => ({
  type: SET_IS_STATIC_ADD_COLUMN_DROPDOWN_MENU_OPEN,
  payload: bool,
});

export const setIsSupersetPickerOpen = (isOpen) => ({
  type: SET_IS_SUPERSET_PICKER_OPEN,
  payload: isOpen,
});

export const setSuperSetPickerOpenById = (assignedId) => ({
  type: SET_SUPERSET_PICKER_OPEN_BY_ID,
  payload: assignedId,
});

export const removeSuperSetPickerOpenById = (assignedId) => ({
  type: REMOVE_SUPERSET_PICKER_OPEN_BY_ID,
  payload: assignedId,
});

export const loadSavedProgram = (accountCode, submissionObject) => (dispatch, getState) => {
  dispatch({ type: LOAD_SAVED_PROGRAM_START });
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  return axiosAuthed
    .post(`/accounts/${accountCode}/calendars/programming/load-program`, submissionObject)
    .then((response) => {
      showSuccessToast('Program loaded successfully');
      dispatch({
        type: LOAD_SAVED_PROGRAM_FULFILLED,
        payload: response.data,
      });
      if (Object.keys(selectedReduxCalendar).length) {
        dispatch(setSelectedReduxCalendar(selectedReduxCalendar));
      } else if (Object.keys(selectedReduxAthlete).length) {
        dispatch(setSelectedReduxAthlete(selectedReduxAthlete));
      }
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred loading the program');
      dispatch({
        type: LOAD_SAVED_PROGRAM_REJECTED,
        payload: err,
      });
    });
};

export const updateWorkoutInfoName = (accountCode, workoutInfo) => (dispatch) => {
  dispatch({ type: UPDATE_WORKOUT_INFO_NAME_START });
  return axiosAuthed.put(`/accounts/${accountCode}/workout-infos`, workoutInfo)
    .then((response) => {
      dispatch({
        type: UPDATE_WORKOUT_INFO_NAME_FULFILLED,
        payload: { data: response.data, formattedDate: workoutInfo.date },
      });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred updating workout info');
      dispatch({
        type: UPDATE_WORKOUT_INFO_NAME_REJECTED,
        payload: error,
      });
    });
};

export const updateNonDateBasedWorkoutInfo = (accountCode, savedWorkoutId, dayNumber, workoutInfo) => (dispatch) => {
  dispatch({ type: UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_START });
  return axiosAuthed.put(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/${dayNumber}`, workoutInfo)
    .then((response) => {
      dispatch({
        type: UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_FULFILLED,
        payload: { data: response.data, dayNumber },
      });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred updating workout info');
      dispatch({
        type: UPDATE_NON_DATE_BASED_WORKOUT_INFO_NAME_REJECTED,
        payload: error,
      });
    });
};

export const updateWorkoutInfoColor = (accountCode, workoutInfo) => (dispatch) => {
  dispatch({ type: UPDATE_WORKOUT_INFO_COLOR_START });
  return axiosAuthed.put(`/accounts/${accountCode}/workout-infos`, workoutInfo)
    .then((response) => {
      dispatch({
        type: UPDATE_WORKOUT_INFO_COLOR_FULFILLED,
        payload: { data: response.data, formattedDate: workoutInfo.date },
      });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred updating workout info color');
      dispatch({
        type: UPDATE_WORKOUT_INFO_COLOR_REJECTED,
        payload: error,
      });
    });
};

export const saveWorkoutTemplate = (accountCode, template) => (dispatch, getState) => {
  dispatch({ type: SAVE_WORKOUT_TEMPLATE });

  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;

  // Format dates to YYYY-MM-DD string format
  const formattedTemplate = {
    ...template,
    startDate: moment(template.startDate).format('YYYY-MM-DD'),
    endDate: moment(template.endDate).format('YYYY-MM-DD'),
    includeWorkoutInfo: template.saveWithTitles,
    includePrescribedLoads: template.saveWithPrescribedLoads,
  };

  // Add calendarId or userId if available
  if (Object.keys(selectedReduxCalendar).length) {
    formattedTemplate.calendarId = selectedReduxCalendar.id;
  } else if (Object.keys(selectedReduxAthlete).length) {
    formattedTemplate.userId = selectedReduxAthlete.id;
  }

  return axiosAuthed.post(`/accounts/${accountCode}/calendars/programming/save-program`, formattedTemplate)
    .then((response) => {
      dispatch({
        type: SAVE_WORKOUT_TEMPLATE_FULFILLED,
        payload: response.data,
      });
      showSuccessToast('Workout template saved successfully');
      return response.data;
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred saving workout template');
      dispatch({
        type: SAVE_WORKOUT_TEMPLATE_REJECTED,
        payload: error,
      });
      throw error;
    });
};

export const shareWorkoutInfo = (accountCode, workoutInfo) => (dispatch) => {
  dispatch({ type: SHARE_WORKOUT_INFO_START });
  return axiosAuthed.post(`/accounts/${accountCode}/calendars/programming/share-link`, workoutInfo)
    .then((response) => {
      dispatch({
        type: SHARE_WORKOUT_INFO_FULFILLED,
        payload: { data: response.data },
      });
      return response.data;
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred sharing workout info');
      dispatch({
        type: SHARE_WORKOUT_INFO_REJECTED,
        payload: error,
      });
      throw error;
    });
};

export const clearWorkoutItems = (accountCode, workoutInfo) => (dispatch, getState) => {
  dispatch({ type: CLEAR_WORKOUT_ITEMS_START });
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  // Create submission object
  const submissionObject = { ...workoutInfo };
  // Add calendarId or userId if available
  // Only strip the opposite key when we're about to set ours - so we never end up with neither
  let isCalendar = false;
  if (Object.keys(selectedReduxAthlete).length) {
    delete submissionObject.calendarId;
    submissionObject.userId = selectedReduxAthlete.id;
  } else if (Object.keys(selectedReduxCalendar).length) {
    delete submissionObject.userId;
    submissionObject.calendarId = selectedReduxCalendar.id;
    isCalendar = true;
  }
  return axiosAuthed.post(`/accounts/${accountCode}/calendars/programming/clear-assignments`, submissionObject)
    .then((response) => {
      showSuccessToast('Workout items cleared successfully');
      dispatch({
        type: CLEAR_WORKOUT_ITEMS_FULFILLED,
        payload: { data: response.data },
      });
      if (isCalendar) {
        dispatch(setSelectedReduxCalendar(selectedReduxCalendar));
      } else {
        dispatch(setSelectedReduxAthlete(selectedReduxAthlete));
      }
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred clearing workout items');
      dispatch({
        type: CLEAR_WORKOUT_ITEMS_REJECTED,
        payload: error,
      });
      throw error;
    });
};

export const copyWorkoutItems = (
  accountCode,
  copyWorkoutParams,
  savedWorkoutId = null,
) => (dispatch, getState) => {
  dispatch({ type: COPY_WORKOUT_ITEMS_START });
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  // Create submission object from params
  const submissionObject = { ...copyWorkoutParams };
  // Use source IDs from params if already provided (e.g., from paste flow),
  // otherwise fall back to currently selected entities
  if (!submissionObject.sourceUserId && !submissionObject.sourceCalendarId) {
    if (Object.keys(selectedReduxAthlete).length) {
      submissionObject.sourceUserId = selectedReduxAthlete.id;
    } else if (Object.keys(selectedReduxCalendar).length) {
      submissionObject.sourceCalendarId = selectedReduxCalendar.id;
    }
  }

  // Determine which endpoint to use
  const endpoint = savedWorkoutId
    ? `/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming/copy-assignments`
    : `/accounts/${accountCode}/calendars/programming/copy-assignments`;

  return axiosAuthed.post(endpoint, submissionObject)
    .then((response) => {
      dispatch({
        type: COPY_WORKOUT_ITEMS_FULFILLED,
        payload: { data: response.data },
      });

      // If we're in program library mode, reload the program data
      if (savedWorkoutId) {
        dispatch(fetchNonDateBasedProgramItemsByDayRange(accountCode, savedWorkoutId));
      }

      // If we're in calendar view, reload the calendar data
      if (Object.keys(selectedReduxCalendar).length) {
        dispatch(setSelectedReduxCalendar(selectedReduxCalendar));
      } else if (Object.keys(selectedReduxAthlete).length) {
        dispatch(setSelectedReduxAthlete(selectedReduxAthlete));
      }
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred copying workout items');
      dispatch({
        type: COPY_WORKOUT_ITEMS_REJECTED,
        payload: error,
      });
      throw error;
    });
};

export const pasteClipboardItems = () => (dispatch, getState) => {
  const {
    copiedSelectedItems,
    selectedDate,
    weekViewExpandedDay,
    selectedReduxCalendar,
    selectedReduxAthlete,
    viewType,
    programType,
  } = getState().calendar.data;
  const { currentUser } = getState().auth.data;

  // Guard: only allow in day view, week view, and non-free-form-program
  if ((viewType !== 'dayView' && viewType !== 'weekView') || programType === 'free-form-program') {
    return;
  }

  // Guard: weekView requires an expanded day
  if (viewType === 'weekView' && !weekViewExpandedDay) {
    showErrorToast('Please expand a day to paste copied items');
    return;
  }

  // Guard: no copied items
  if (!copiedSelectedItems) {
    showErrorToast('No items in clipboard. Copy items first with Cmd/Ctrl+C');
    return;
  }

  // Guard: cross-mode copying not allowed (must paste in same mode as copy)
  if (copiedSelectedItems.programType !== programType) {
    showErrorToast('Cannot paste items copied from a different program type');
    return;
  }

  // Build sourceAssignedIds from copied items (filter out pre-save items)
  const sourceAssignedIds = Object.values(copiedSelectedItems.items)
    .map((item) => item.assignedId)
    .filter((id) => id !== undefined && id !== null && typeof id === 'number');

  // Guard: no valid assigned IDs
  if (sourceAssignedIds.length === 0) {
    showErrorToast('No saved items to paste. Unsaved items cannot be pasted');
    return;
  }

  // Determine target date based on view type
  let targetDate;
  if (viewType === 'weekView') {
    targetDate = weekViewExpandedDay; // Already in YYYY-MM-DD format
  } else {
    if (!selectedDate) {
      return;
    }
    targetDate = moment(selectedDate).format('YYYY-MM-DD');
  }

  // Build payload for date-based calendar copy (non-date-based modes are already guarded against)
  const payload = {
    clearExisting: false,
    copyType: 'individual-assignments',
    includePrescribedLoads: true,
    includeWorkoutInfo: false,
    sourceAssignedIds,
    sourceDateStart: copiedSelectedItems.sourceDate,
    sourceDateEnd: copiedSelectedItems.sourceDate,
    targetDateStart: targetDate,
    targetDateEnd: targetDate,
    targetDays: [],
    targetOrderLocation: 'bottom',
  };

  // Add source IDs from the stored clipboard context (where items were copied from)
  const { sourceCalendar, sourceAthlete } = copiedSelectedItems;
  if (sourceAthlete && Object.keys(sourceAthlete).length > 0) {
    payload.sourceUserId = sourceAthlete.id;
  } else if (sourceCalendar && Object.keys(sourceCalendar).length > 0) {
    payload.sourceCalendarId = sourceCalendar.id;
  }

  // Add target IDs based on current selection (where items are being pasted to)
  if (Object.keys(selectedReduxAthlete).length > 0) {
    const athleteId = selectedReduxAthlete.userId || selectedReduxAthlete.id;
    const parsedAthleteId = Number(athleteId);
    if (!Number.isNaN(parsedAthleteId) && parsedAthleteId) {
      payload.targetUserIds = [parsedAthleteId];
    }
  } else if (Object.keys(selectedReduxCalendar).length > 0) {
    const parsedCalendarId = Number(selectedReduxCalendar.id);
    if (!Number.isNaN(parsedCalendarId) && parsedCalendarId) {
      payload.targetCalendarIds = [parsedCalendarId];
    }
  }

  dispatch(copyWorkoutItems(currentUser.accountCode, payload, null));
};

export const fetchCalendarPickerItems = (
  currentUser,
  firstDayMonth,
  lastDayMonth,
) => (dispatch, getState) => {
  dispatch({ type: FETCH_CALENDAR_PICKER_ITEMS_START });
  const { selectedReduxCalendar, selectedReduxAthlete } = getState().calendar.data;
  let idParam = '';
  if (selectedReduxCalendar && Object.keys(selectedReduxCalendar).length) {
    idParam = `calendarId=${selectedReduxCalendar.id}`;
  } else if (selectedReduxAthlete && Object.keys(selectedReduxAthlete).length) {
    idParam = `athleteId=${selectedReduxAthlete.id}`;
  }
  axiosAuthed
    .get(`/accounts/${currentUser.accountCode}/calendars/programming/overview?endDate=${lastDayMonth}&startDate=${firstDayMonth}&${idParam}`)
    .then((response) => {
      dispatch({
        payload: {
          data: response.data,
        },
        type: FETCH_CALENDAR_PICKER_ITEMS_FULFILLED,
      });
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred getting calendar picker items');
      dispatch({
        payload:
            err?.response?.headers?.message
            || err?.response?.data?.message
            || 'An error has occurred getting calendar picker items',
        type: FETCH_CALENDAR_PICKER_ITEMS_REJECTED,
      });
    });
};

export const updateCalendarSettings = (accountCode, userId, settings, { onSuccess, onError } = {}) => (dispatch) => {
  dispatch({ type: UPDATE_CALENDAR_SETTINGS_START });

  const requestBody = {
    user: {
      defaultCalendar: settings.defaultCalendar,
    },
  };

  return axiosAuthed.put(`/accounts/${accountCode}/users/${userId}`, requestBody)
    .then((response) => {
      dispatch({
        type: UPDATE_CALENDAR_SETTINGS_FULFILLED,
        payload: response.data,
      });
      showSuccessToast('Calendar settings updated successfully');
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred updating calendar settings');
      dispatch({
        type: UPDATE_CALENDAR_SETTINGS_REJECTED,
        payload: error,
      });
      if (onError) {
        onError(error?.response?.headers?.message);
      }
    });
};

export const fetchAndSetDefaultCalendar = (currentUser) => (dispatch) => {
  dispatch({ type: FETCH_AND_SET_DEFAULT_CALENDAR_START });

  if (!currentUser?.defaultCalendar) {
    dispatch({ type: FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED });
    return;
  }

  const {
    accountCode, defaultCalendar, defaultCalendarParentId,
  } = currentUser;
  let endpoint;

  if (defaultCalendarParentId) {
    endpoint = `/accounts/${accountCode}/calendars/${defaultCalendarParentId}/children/${defaultCalendar}`;
  } else {
    endpoint = `/accounts/${accountCode}/calendars/${defaultCalendar}`;
  }

  axiosAuthed.get(endpoint)
    .then((response) => {
      const calendarData = Array.isArray(response.data) ? response.data[0] : response.data;
      dispatch({
        type: FETCH_AND_SET_DEFAULT_CALENDAR_FULFILLED,
        payload: calendarData,
      });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred fetching default calendar');
      dispatch({
        type: FETCH_AND_SET_DEFAULT_CALENDAR_REJECTED,
        payload: error,
      });
    });
};

export const fetchAndSetUrlAthlete = (accountCode, userId) => (dispatch) => {
  dispatch({ type: FETCH_AND_SET_URL_ATHLETE_START });

  if (!userId || !accountCode) {
    dispatch({ type: FETCH_AND_SET_URL_ATHLETE_REJECTED });
    return;
  }

  const endpoint = `/accounts/${accountCode}/users/${userId}`;

  axiosAuthed.get(endpoint)
    .then((response) => {
      const athleteData = Array.isArray(response.data) ? response.data[0] : response.data;
      dispatch({
        type: FETCH_AND_SET_URL_ATHLETE_FULFILLED,
        payload: athleteData,
      });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred fetching athlete');
      dispatch({
        type: FETCH_AND_SET_URL_ATHLETE_REJECTED,
        payload: error,
      });
    });
};

export const fetchAndSetUrlCalendar = (accountCode, calendarId) => (dispatch) => {
  dispatch({ type: FETCH_AND_SET_URL_CALENDAR_START });

  if (!calendarId || !accountCode) {
    dispatch({ type: FETCH_AND_SET_URL_CALENDAR_REJECTED });
    return;
  }

  const endpoint = `/accounts/${accountCode}/calendars/${calendarId}`;

  axiosAuthed.get(endpoint)
    .then((response) => {
      const calendarData = Array.isArray(response.data) ? response.data[0] : response.data;
      dispatch({
        type: FETCH_AND_SET_URL_CALENDAR_FULFILLED,
        payload: calendarData,
      });
      dispatch({
        type: SET_SELECTED_REDUX_CALENDAR,
        payload: calendarData,
      });
      dispatch({ type: SET_PROGRAM_TYPE, payload: 'calendar' });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred fetching calendar');
      dispatch({
        type: FETCH_AND_SET_URL_CALENDAR_REJECTED,
        payload: error,
      });
    });
};

export const fetchAndSetUrlProgram = (accountCode, programId) => (dispatch) => {
  dispatch({ type: FETCH_AND_SET_URL_PROGRAM_START });

  if (!programId || !accountCode) {
    dispatch({ type: FETCH_AND_SET_URL_PROGRAM_REJECTED });
    return;
  }

  const endpoint = `/accounts/${accountCode}/workouts/saved-workouts/${programId}`;

  axiosAuthed.get(endpoint)
    .then((response) => {
      const programData = Array.isArray(response.data) ? response.data[0] : response.data;
      dispatch({
        type: FETCH_AND_SET_URL_PROGRAM_FULFILLED,
        payload: programData,
      });
      dispatch({
        type: SET_SELECTED_REDUX_NON_DATE_BASED_PROGRAM,
        payload: programData,
      });
      dispatch({ type: SET_PROGRAM_TYPE, payload: 'free-form-program' });
    })
    .catch((error) => {
      showErrorToast(error?.response?.headers?.message || 'An error has occurred fetching program');
      dispatch({
        type: FETCH_AND_SET_URL_PROGRAM_REJECTED,
        payload: error,
      });
    });
};

export const createParentCalendar = (values) => (
  (dispatch) => {
    dispatch({ type: CREATE_PARENT_CALENDAR_START });
    axiosAuthed.post(`/accounts/${values.accountCode}/calendars`, values)
      .then((response) => {
        dispatch({
          type: CREATE_PARENT_CALENDAR_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: CREATE_PARENT_CALENDAR_REJECTED,
          payload:
            err?.response?.headers?.message
                || err?.response?.data?.message
                || err,
        });
      });
  }
);
export const createSavedWorkout = (accountCode, values) => (
  (dispatch) => {
    dispatch({ type: CREATE_A_SAVED_WORKOUT_START });
    axiosAuthed.post(`/accounts/${accountCode}/workouts/saved-workouts`, values)
      .then((response) => {
        dispatch({
          type: CREATE_A_SAVED_WORKOUT_FULFILLED,
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: CREATE_A_SAVED_WORKOUT_REJECTED,
          payload:
            err?.response?.headers?.message
                || err?.response?.data?.message
                || err,
        });
      });
  }
);

export const createParentChildCalendar = (values) => (
  (dispatch) => {
    dispatch({ type: CREATE_PARENT_CHILD_CALENDAR_START });
    axiosAuthed.post(`/accounts/${values.accountCode}/calendars/${values.parentId}/children`, values)
      .then((response) => {
        // Handle case where API returns array vs object (like fetchAndSetDefaultCalendar)
        const calendarData = Array.isArray(response.data) ? response.data[0] : response.data;
        dispatch({
          type: CREATE_PARENT_CHILD_CALENDAR_FULFILLED,
          payload: {
            ...calendarData,
            parentId: values.parentId,
            parentName: values.parentName,
          },
        });
      })
      .catch((err) => {
        dispatch({
          type: CREATE_PARENT_CHILD_CALENDAR_REJECTED,
          payload: err,
        });
      });
  }
);

export const fetchWorkoutTemplateData = (
  currentUser,
  startDate,
  endDate,
) => (dispatch, getState) => {
  dispatch({ type: FETCH_WORKOUT_TEMPLATE_DATA_START });
  const { selectedReduxCalendar } = getState().calendar.data;
  const { selectedReduxAthlete } = getState().calendar.data;

  let endpoint = '';
  const formattedStartDate = moment(startDate).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDate).format('YYYY-MM-DD');

  if (Object.keys(selectedReduxCalendar).length) {
    endpoint = `/accounts/${currentUser.accountCode}/calendars/programming?endDate=${formattedEndDate}&startDate=${formattedStartDate}&calendarId=${selectedReduxCalendar.id}`;
  } else if (Object.keys(selectedReduxAthlete).length) {
    endpoint = `/accounts/${currentUser.accountCode}/calendars/programming?endDate=${formattedEndDate}&startDate=${formattedStartDate}&athleteId=${selectedReduxAthlete.id}`;
  } else {
    // Fallback - this shouldn't happen but just in case
    endpoint = `/accounts/${currentUser.accountCode}/calendars/programming?endDate=${formattedEndDate}&startDate=${formattedStartDate}`;
  }

  return axiosAuthed
    .get(endpoint)
    .then((response) => {
      const object = {};
      for (let i = 0; i < response.data.assignments.length; i += 1) {
        object[response.data.assignments[i].date] = response.data.assignments[i];
      }

      dispatch({
        payload: {
          data: object,
        },
        type: FETCH_WORKOUT_TEMPLATE_DATA_FULFILLED,
      });

      return object;
    })
    .catch((err) => {
      showErrorToast(err?.response?.headers?.message || 'An error has occurred getting workout template data');
      dispatch({
        payload:
            err?.response?.headers?.message
            || err?.response?.data?.message
            || 'An error has occurred getting workout template data',
        type: FETCH_WORKOUT_TEMPLATE_DATA_REJECTED,
      });
      throw err;
    });
};

export const setViewType = (viewType) => (dispatch, getState) => {
  const state = getState();
  const currentViewType = state.calendar.data.viewType;
  const expandedDay = state.calendar.data.weekViewExpandedDay;

  // Dispatch the view type change
  dispatch({
    type: SET_VIEW_TYPE,
    payload: viewType,
  });

  /** Clear stale expansion/selection state when switching views so the
   *  new view's DraggableContainer doesn't render one frame with
   *  stale expanded heights before the per-container useEffect fires.
   */
  if (currentViewType !== viewType) {
    dispatch(setExpandedItems({}));
    dispatch(setSelectedItems({}));
  }

  // If switching from week view to day view AND there's an expanded day, set it as selectedDate
  if (currentViewType === 'weekView' && viewType === 'dayView' && expandedDay) {
    dispatch(setSelectedDate(moment(expandedDay)));
  }
};

export const setProgramType = (programType) => (
  {
    type: SET_PROGRAM_TYPE,
    payload: programType,
  }
);

export const setCreateModalProgramType = (programType) => (
  {
    type: SET_CREATE_MODAL_PROGRAM_TYPE,
    payload: programType,
  }
);

// Namespaced actions for week view support
export const setCalendarItemsNamespaced = (calendarItemsArray, date, namespace) => (
  {
    type: `${namespace}/${SET_CALENDAR_ITEMS_NAMESPACED}`,
    payload: {
      calendarItemsArray,
      date,
      namespace,
    },
  }
);

export const updateCalendarItemsOrderNamespaced = (accountCode, submissionObject, originalItems, namespace) => (
  (dispatch) => {
    dispatch({
      type: `${namespace}/${UPDATE_CALENDAR_ITEMS_ORDER_START_NAMESPACED}`,
      payload: { namespace },
    });

    return axiosAuthed.post(`/organization/${accountCode}/calendar-items/reorder`, submissionObject, {
      requestId: `${namespace}/updateCalendarItemsOrder`,
    })
      .then((response) => {
        dispatch({
          type: `${namespace}/${UPDATE_CALENDAR_ITEMS_ORDER_FULFILLED_NAMESPACED}`,
          payload: {
            data: response.data,
            originalItems,
            namespace,
          },
        });
        return response;
      })
      .catch((err) => {
        dispatch({
          type: `${namespace}/${UPDATE_CALENDAR_ITEMS_ORDER_REJECTED_NAMESPACED}`,
          payload: {
            error: err?.response?.data?.message || 'An error has occurred updating calendar items order',
            namespace,
          },
        });
        throw err;
      });
  }
);

export const addPreSavedItemToCalendarItemsArrayNamespaced = (copiedItem, endpointFormattedDate, destinationIndex, namespace) => (
  {
    type: `${namespace}/${ADD_PRESAVED_ITEM_TO_CALENDAR_ITEMS_ARRAY_NAMESPACED}`,
    payload: {
      copiedItem,
      endpointFormattedDate,
      destinationIndex,
      namespace,
    },
  }
);

export const setCombineWithInfoNamespaced = (combineInfo, namespace) => (
  {
    type: `${namespace}/${SET_COMBINE_WITH_INFO_NAMESPACED}`,
    payload: {
      combineInfo,
      namespace,
    },
  }
);

export const duplicateWeek = (accountCode, savedWorkoutId, weekNumber, { onSuccess, onError } = {}) => (
  dispatch,
) => {
  dispatch({ type: DUPLICATE_WEEK_START });
  axiosAuthed
    .post(`/accounts/${accountCode}/workouts/saved-workouts/${savedWorkoutId}/programming/copy-week`, { weekNumber })
    .then((response) => {
      showSuccessToast('Week Duplicated!');
      dispatch({
        type: DUPLICATE_WEEK_FULFILLED,
        payload: response.data,
      });
      if (onSuccess) {
        onSuccess(response.data);
      }
    })
    .catch((err) => {
      if (err?.response?.headers?.message === 'No assignments are assigned to the requested day.') {
        showErrorToast('Can not duplicate a week with no saved items.');
      } else {
        showErrorToast(err?.response?.headers?.message || 'An error has occurred duplicating the week');
      }
      dispatch({
        type: DUPLICATE_WEEK_REJECTED,
        payload: err,
      });
      if (onError) {
        onError(err.message);
      }
    });
};

export const setActiveExerciseId = (assignedId) => ({
  type: SET_ACTIVE_EXERCISE_ID,
  payload: assignedId,
});
